// Auto-generated from Croquettes.xlsx — do not edit manually
export interface FoodItem {
  id: number;
  species: "dog" | "cat";
  type: "dry" | "wet";
  gamme: string;
  brand: string;
  name: string;
  energy_kcal_kg: number;
  protein_pct: number | null;
  rpc: number | null;
  phosphorus_pct: number | null;
  p_g_mcal: number | null;
  rpp: string | null;
  calcium_pct: number | null;
  ca_g_mcal: number | null;
  ca_p_ratio: number | null;
}

export const FOODS_DATA: FoodItem[] = [
  {
    id: 0,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Royal Canin",
    name: "Mini/Medium Starter mother and baby dog",
    energy_kcal_kg: 4200.0,
    protein_pct: 30.0,
    rpc: 71.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 1,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Royal Canin",
    name: "Maxi/Giant Starter mother and baby dog",
    energy_kcal_kg: 4170.0,
    protein_pct: 30.0,
    rpc: 72.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 2,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Royal Canin",
    name: "X-small/Mini/Medium Puppy",
    energy_kcal_kg: 4120.0,
    protein_pct: 30.0,
    rpc: 73.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 3,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Royal Canin",
    name: "Maxi puppy",
    energy_kcal_kg: 3850.0,
    protein_pct: 30.0,
    rpc: 78.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 4,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Royal Canin",
    name: "Giant puppy",
    energy_kcal_kg: 3870.0,
    protein_pct: 34.0,
    rpc: 88.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.6,
    rpp: null,
    calcium_pct: 1.31,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 5,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Royal Canin",
    name: "Junior Giant",
    energy_kcal_kg: 3960.0,
    protein_pct: 31.0,
    rpc: 78.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 6,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Virbac",
    name: "Baby small&toy",
    energy_kcal_kg: 3960.0,
    protein_pct: 35.0,
    rpc: 88.0,
    phosphorus_pct: 1.1,
    p_g_mcal: 2.8,
    rpp: null,
    calcium_pct: 1.2,
    ca_g_mcal: 3.0,
    ca_p_ratio: 1.09,
  },
  {
    id: 7,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Virbac",
    name: "Baby large&medium",
    energy_kcal_kg: 3960.0,
    protein_pct: 35.0,
    rpc: 88.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: 1.2,
    ca_g_mcal: 3.0,
    ca_p_ratio: 1.2,
  },
  {
    id: 8,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Virbac",
    name: "Junior special medium",
    energy_kcal_kg: 3830.0,
    protein_pct: 35.0,
    rpc: 91.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.6,
    rpp: null,
    calcium_pct: 1.3,
    ca_g_mcal: 3.4,
    ca_p_ratio: 1.3,
  },
  {
    id: 9,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Virbac",
    name: "Junior special large",
    energy_kcal_kg: 3580.0,
    protein_pct: 37.0,
    rpc: 102.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: 1.1,
    ca_g_mcal: 3.1,
    ca_p_ratio: 1.22,
  },
  {
    id: 10,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Specific",
    name: "CPD-S puppy small breed",
    energy_kcal_kg: 3860.0,
    protein_pct: 26.0,
    rpc: 66.0,
    phosphorus_pct: 0.87,
    p_g_mcal: 2.3,
    rpp: null,
    calcium_pct: 0.97,
    ca_g_mcal: 2.5,
    ca_p_ratio: 1.11,
  },
  {
    id: 11,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Specific",
    name: "CPD-M puppy medium breed",
    energy_kcal_kg: 3860.0,
    protein_pct: 26.0,
    rpc: 66.0,
    phosphorus_pct: 0.87,
    p_g_mcal: 2.3,
    rpp: null,
    calcium_pct: 0.97,
    ca_g_mcal: 2.5,
    ca_p_ratio: 1.11,
  },
  {
    id: 12,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Specific",
    name: "CPD-XL puppy large and giant breed",
    energy_kcal_kg: 3650.0,
    protein_pct: 26.0,
    rpc: 72.0,
    phosphorus_pct: 0.72,
    p_g_mcal: 2.0,
    rpp: null,
    calcium_pct: 0.79,
    ca_g_mcal: 2.2,
    ca_p_ratio: 1.1,
  },
  {
    id: 13,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Proplan",
    name: "Small&mini puppy Healthy start Poulet",
    energy_kcal_kg: 4133.0,
    protein_pct: 32.0,
    rpc: 77.0,
    phosphorus_pct: 1.05,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: 1.5,
    ca_g_mcal: 3.6,
    ca_p_ratio: 1.43,
  },
  {
    id: 14,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Proplan",
    name: "Small&mini puppy sensitive skin",
    energy_kcal_kg: 4133.0,
    protein_pct: 32.0,
    rpc: 77.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.4,
    rpp: null,
    calcium_pct: 1.4,
    ca_g_mcal: 3.4,
    ca_p_ratio: 1.4,
  },
  {
    id: 15,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Proplan",
    name: "Medium puppy Healthy start",
    energy_kcal_kg: 4050.0,
    protein_pct: 30.0,
    rpc: 74.0,
    phosphorus_pct: 1.02,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: 1.5,
    ca_g_mcal: 3.7,
    ca_p_ratio: 1.47,
  },
  {
    id: 16,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Proplan",
    name: "Medium puppy sensitive digestion",
    energy_kcal_kg: 4000.0,
    protein_pct: 30.0,
    rpc: 75.0,
    phosphorus_pct: 0.96,
    p_g_mcal: 2.4,
    rpp: null,
    calcium_pct: 1.5,
    ca_g_mcal: 3.8,
    ca_p_ratio: 1.56,
  },
  {
    id: 17,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Proplan",
    name: "Medium puppy sensitive skin",
    energy_kcal_kg: 4065.0,
    protein_pct: 32.0,
    rpc: 79.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: 1.5,
    ca_g_mcal: 3.7,
    ca_p_ratio: 1.5,
  },
  {
    id: 18,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Proplan",
    name: "Large athletic puppy Healthy start",
    energy_kcal_kg: 4011.0,
    protein_pct: 32.0,
    rpc: 80.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: 1.36,
    ca_g_mcal: 3.4,
    ca_p_ratio: 1.36,
  },
  {
    id: 19,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Proplan",
    name: "Large athletic puppy sensitive digestion",
    energy_kcal_kg: 3972.0,
    protein_pct: 32.0,
    rpc: 81.0,
    phosphorus_pct: 0.95,
    p_g_mcal: 2.4,
    rpp: null,
    calcium_pct: 1.36,
    ca_g_mcal: 3.4,
    ca_p_ratio: 1.43,
  },
  {
    id: 20,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Proplan",
    name: "Large robust puppy Healthy start",
    energy_kcal_kg: 3823.0,
    protein_pct: 29.0,
    rpc: 76.0,
    phosphorus_pct: 1.02,
    p_g_mcal: 2.7,
    rpp: null,
    calcium_pct: 1.44,
    ca_g_mcal: 3.8,
    ca_p_ratio: 1.41,
  },
  {
    id: 21,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Proplan",
    name: "Large robust puppysensitive digestion",
    energy_kcal_kg: 3805.0,
    protein_pct: 29.0,
    rpc: 76.0,
    phosphorus_pct: 0.92,
    p_g_mcal: 2.4,
    rpp: null,
    calcium_pct: 1.45,
    ca_g_mcal: 3.8,
    ca_p_ratio: 1.58,
  },
  {
    id: 22,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Hill's",
    name: "Multi-benefit Puppy small&mini",
    energy_kcal_kg: 3992.0,
    protein_pct: 28.0,
    rpc: 70.0,
    phosphorus_pct: 1.1,
    p_g_mcal: 2.8,
    rpp: null,
    calcium_pct: 1.5,
    ca_g_mcal: 3.8,
    ca_p_ratio: 1.36,
  },
  {
    id: 23,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Hill's",
    name: "Multi-benefit Puppy medium",
    energy_kcal_kg: 3992.0,
    protein_pct: 28.0,
    rpc: 70.0,
    phosphorus_pct: 1.1,
    p_g_mcal: 2.8,
    rpp: null,
    calcium_pct: 1.5,
    ca_g_mcal: 3.8,
    ca_p_ratio: 1.36,
  },
  {
    id: 24,
    species: "dog",
    type: "dry",
    gamme: "Chiot",
    brand: "Hill's",
    name: "Multi-benefit Puppy large breed",
    energy_kcal_kg: 3959.0,
    protein_pct: 28.0,
    rpc: 71.0,
    phosphorus_pct: 0.85,
    p_g_mcal: 2.1,
    rpp: null,
    calcium_pct: 1.1,
    ca_g_mcal: 2.8,
    ca_p_ratio: 1.29,
  },
  {
    id: 25,
    species: "dog",
    type: "dry",
    gamme: "Chiot st\u00e9rilis\u00e9",
    brand: "Royal canin",
    name: "Neutered junior",
    energy_kcal_kg: 3920.0,
    protein_pct: 30.0,
    rpc: 77.0,
    phosphorus_pct: 0.97,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: 1.25,
    ca_g_mcal: 3.2,
    ca_p_ratio: 1.29,
  },
  {
    id: 26,
    species: "dog",
    type: "dry",
    gamme: "Chiot st\u00e9rilis\u00e9",
    brand: "Royal canin",
    name: "Neutered junior large dog",
    energy_kcal_kg: 3760.0,
    protein_pct: 31.0,
    rpc: 82.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.4,
    rpp: null,
    calcium_pct: 1.2,
    ca_g_mcal: 3.2,
    ca_p_ratio: 1.33,
  },
  {
    id: 27,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Virbac",
    name: "Adult small & toy",
    energy_kcal_kg: 3700.0,
    protein_pct: 34.0,
    rpc: 92.0,
    phosphorus_pct: 1.1,
    p_g_mcal: 3.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 28,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Virbac",
    name: "Adult large&medium",
    energy_kcal_kg: 3700.0,
    protein_pct: 34.0,
    rpc: 92.0,
    phosphorus_pct: 1.1,
    p_g_mcal: 3.0,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 29,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Royal Canin",
    name: "Adult small dog",
    energy_kcal_kg: 3930.0,
    protein_pct: 25.0,
    rpc: 64.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 1.8,
    rpp: "36",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 30,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Royal Canin",
    name: "Adult",
    energy_kcal_kg: 3980.0,
    protein_pct: 23.0,
    rpc: 58.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 31,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Royal Canin",
    name: "Adult large dog",
    energy_kcal_kg: 4000.0,
    protein_pct: 25.0,
    rpc: 63.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 32,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Royal Canin",
    name: "Adult giant dog",
    energy_kcal_kg: 4180.0,
    protein_pct: 26.0,
    rpc: 62.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 33,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Specific",
    name: "CXD-S Adult small breed",
    energy_kcal_kg: 3730.0,
    protein_pct: 23.0,
    rpc: 62.0,
    phosphorus_pct: 0.69,
    p_g_mcal: 1.8,
    rpp: "34",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 34,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Specific",
    name: "CXD-M Adult medium breed",
    energy_kcal_kg: 3730.0,
    protein_pct: 23.0,
    rpc: 62.0,
    phosphorus_pct: 0.68,
    p_g_mcal: 1.8,
    rpp: "34",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 35,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Specific",
    name: "CXD-XL Adult large&giant breed",
    energy_kcal_kg: 3670.0,
    protein_pct: 23.0,
    rpc: 63.0,
    phosphorus_pct: 0.67,
    p_g_mcal: 1.8,
    rpp: "34",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 36,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit small&mini adult",
    energy_kcal_kg: 3917.0,
    protein_pct: 22.0,
    rpc: 55.0,
    phosphorus_pct: 0.64,
    p_g_mcal: 1.6,
    rpp: "34",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 37,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit medium adult",
    energy_kcal_kg: 3917.0,
    protein_pct: 22.0,
    rpc: 55.0,
    phosphorus_pct: 0.64,
    p_g_mcal: 1.6,
    rpp: "34",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 38,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit large breed adult",
    energy_kcal_kg: 3917.0,
    protein_pct: 22.0,
    rpc: 55.0,
    phosphorus_pct: 0.64,
    p_g_mcal: 1.6,
    rpp: "34",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 39,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit + Digestion Adult small&mini",
    energy_kcal_kg: 3263.0,
    protein_pct: 26.0,
    rpc: 80.0,
    phosphorus_pct: 0.66,
    p_g_mcal: 2.0,
    rpp: "39",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 40,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit + Digestion Adult medium",
    energy_kcal_kg: 3263.0,
    protein_pct: 26.0,
    rpc: 80.0,
    phosphorus_pct: 0.63,
    p_g_mcal: 1.9,
    rpp: "41",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 41,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit + Digestion Adult large",
    energy_kcal_kg: 3263.0,
    protein_pct: 26.0,
    rpc: 80.0,
    phosphorus_pct: 0.66,
    p_g_mcal: 2.0,
    rpp: "39",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 42,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit + Dental Health Adult Small&mini",
    energy_kcal_kg: 2920.0,
    protein_pct: 17.0,
    rpc: 57.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 43,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit + Dental Health Adult medium&large",
    energy_kcal_kg: 3430.0,
    protein_pct: 23.0,
    rpc: 67.0,
    phosphorus_pct: 0.54,
    p_g_mcal: 1.6,
    rpp: "43",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 44,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Small&min Adult Everyday nutrition",
    energy_kcal_kg: 3950.0,
    protein_pct: 28.0,
    rpc: 71.0,
    phosphorus_pct: 0.98,
    p_g_mcal: 2.5,
    rpp: "29",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 45,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Medium Adult Everyday nutrition",
    energy_kcal_kg: 3895.0,
    protein_pct: 26.0,
    rpc: 67.0,
    phosphorus_pct: 0.87,
    p_g_mcal: 2.2,
    rpp: "30",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 46,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Large Robust Adult Everyday nutrition",
    energy_kcal_kg: 3677.0,
    protein_pct: 27.0,
    rpc: 73.0,
    phosphorus_pct: 0.99,
    p_g_mcal: 2.7,
    rpp: "27",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 47,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Large Athletic Adult Everyday nutrition",
    energy_kcal_kg: 3996.0,
    protein_pct: 28.0,
    rpc: 70.0,
    phosphorus_pct: 0.95,
    p_g_mcal: 2.4,
    rpp: "29",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 48,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Small&mini Adult Sensitive skin",
    energy_kcal_kg: 3965.0,
    protein_pct: 30.0,
    rpc: 76.0,
    phosphorus_pct: 0.99,
    p_g_mcal: 2.5,
    rpp: "30",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 49,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Medium Adult Sensitive skin",
    energy_kcal_kg: 3941.0,
    protein_pct: 29.0,
    rpc: 74.0,
    phosphorus_pct: 0.84,
    p_g_mcal: 2.1,
    rpp: "35",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 50,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Large Robust Adult Sensitive skin",
    energy_kcal_kg: 3687.0,
    protein_pct: 27.0,
    rpc: 73.0,
    phosphorus_pct: 0.78,
    p_g_mcal: 2.1,
    rpp: "35",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 51,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Large Athletic Adult Sensitive skin",
    energy_kcal_kg: 3677.0,
    protein_pct: 28.0,
    rpc: 76.0,
    phosphorus_pct: 0.86,
    p_g_mcal: 2.3,
    rpp: "33",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 52,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Small&mini Adult Sensitive digestion",
    energy_kcal_kg: 3912.0,
    protein_pct: 28.0,
    rpc: 72.0,
    phosphorus_pct: 0.93,
    p_g_mcal: 2.4,
    rpp: "30",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 53,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Medium Adult Sensitive digestion",
    energy_kcal_kg: 3858.0,
    protein_pct: 26.0,
    rpc: 67.0,
    phosphorus_pct: 0.81,
    p_g_mcal: 2.1,
    rpp: "32",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 54,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Large Robust Adult Sensitive digestion",
    energy_kcal_kg: 3735.0,
    protein_pct: 27.0,
    rpc: 72.0,
    phosphorus_pct: 0.84,
    p_g_mcal: 2.2,
    rpp: "32",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 55,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Large Athletic Adult Sensitive digestion",
    energy_kcal_kg: 3996.0,
    protein_pct: 28.0,
    rpc: 70.0,
    phosphorus_pct: 0.84,
    p_g_mcal: 2.1,
    rpp: "33",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 56,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Small&mini Adult duo delice",
    energy_kcal_kg: 3914.0,
    protein_pct: 27.0,
    rpc: 69.0,
    phosphorus_pct: 0.82,
    p_g_mcal: 2.1,
    rpp: "33",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 57,
    species: "dog",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Medium&large Adult duo delice",
    energy_kcal_kg: 3777.0,
    protein_pct: 25.0,
    rpc: 66.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 2.1,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 58,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Virbac",
    name: "Adult neutered dog small&toy",
    energy_kcal_kg: 3150.0,
    protein_pct: 34.0,
    rpc: 108.0,
    phosphorus_pct: 1.1,
    p_g_mcal: 3.5,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 59,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Virbac",
    name: "Adult neutered dog large&medium",
    energy_kcal_kg: 3150.0,
    protein_pct: 34.0,
    rpc: 108.0,
    phosphorus_pct: 1.1,
    p_g_mcal: 3.5,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 60,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Neutered adult small dog",
    energy_kcal_kg: 3360.0,
    protein_pct: 30.0,
    rpc: 89.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.8,
    rpp: "50",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 61,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Neutered adult",
    energy_kcal_kg: 3370.0,
    protein_pct: 28.0,
    rpc: 83.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.8,
    rpp: "47",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 62,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Neutered adult large dog",
    energy_kcal_kg: 3355.0,
    protein_pct: 28.0,
    rpc: 83.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.8,
    rpp: "47",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 63,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Hill's",
    name: "Multi-benefit + Weight small&mini adult",
    energy_kcal_kg: 3201.0,
    protein_pct: 26.0,
    rpc: 82.0,
    phosphorus_pct: 0.64,
    p_g_mcal: 2.0,
    rpp: "41",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 64,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Hill's",
    name: "Multi-benefit + Weight medium adult",
    energy_kcal_kg: 3201.0,
    protein_pct: 26.0,
    rpc: 82.0,
    phosphorus_pct: 0.64,
    p_g_mcal: 2.0,
    rpp: "41",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 65,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Hill's",
    name: "Multi-benefit + Weight large breed adult",
    energy_kcal_kg: 3201.0,
    protein_pct: 26.0,
    rpc: 82.0,
    phosphorus_pct: 0.64,
    p_g_mcal: 2.0,
    rpp: "41",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 66,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "Small&mini Adult light/sterilised",
    energy_kcal_kg: 3477.0,
    protein_pct: 29.0,
    rpc: 83.0,
    phosphorus_pct: 0.92,
    p_g_mcal: 2.6,
    rpp: "32",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 67,
    species: "dog",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "All size Adult light/sterilised",
    energy_kcal_kg: 3470.0,
    protein_pct: 27.0,
    rpc: 78.0,
    phosphorus_pct: 0.92,
    p_g_mcal: 2.7,
    rpp: "29",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 68,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Virbac",
    name: "Senior small&toy",
    energy_kcal_kg: 3260.0,
    protein_pct: 32.0,
    rpc: 98.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.1,
    rpp: "46",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 69,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Virbac",
    name: "Senior large&medium",
    energy_kcal_kg: 3270.0,
    protein_pct: 32.0,
    rpc: 98.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.1,
    rpp: "46",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 70,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Virbac",
    name: "Senior neutered dog small&toy",
    energy_kcal_kg: 3110.0,
    protein_pct: 32.0,
    rpc: 103.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.3,
    rpp: "46",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 71,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Virbac",
    name: "Senior neutered dog large&medium",
    energy_kcal_kg: 3110.0,
    protein_pct: 32.0,
    rpc: 103.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.3,
    rpp: "46",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 72,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Royal Canin",
    name: "Mature small dog",
    energy_kcal_kg: 3480.0,
    protein_pct: 25.0,
    rpc: 72.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.7,
    rpp: "42",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 73,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Royal Canin",
    name: "Mature",
    energy_kcal_kg: 3480.0,
    protein_pct: 23.0,
    rpc: 66.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.7,
    rpp: "38",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 74,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Royal Canin",
    name: "Mature large dog",
    energy_kcal_kg: 3530.0,
    protein_pct: 25.0,
    rpc: 71.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.7,
    rpp: "42",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 75,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Specific",
    name: "CGD-S Senior small breed",
    energy_kcal_kg: 3590.0,
    protein_pct: 20.0,
    rpc: 56.0,
    phosphorus_pct: 0.52,
    p_g_mcal: 1.4,
    rpp: "38",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 76,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Specific",
    name: "CGD-M Senior medium breed",
    energy_kcal_kg: 3590.0,
    protein_pct: 20.0,
    rpc: 56.0,
    phosphorus_pct: 0.52,
    p_g_mcal: 1.4,
    rpp: "38",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 77,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Specific",
    name: "CGD-XL Senior large&giant breed",
    energy_kcal_kg: 3550.0,
    protein_pct: 20.0,
    rpc: 56.0,
    phosphorus_pct: 0.52,
    p_g_mcal: 1.5,
    rpp: "38",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 78,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Hill's Vet essentials",
    name: "Multi-benefit + Senior Health small&mini",
    energy_kcal_kg: 3819.0,
    protein_pct: 21.0,
    rpc: 56.0,
    phosphorus_pct: 0.61,
    p_g_mcal: 1.6,
    rpp: "35",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 79,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Hill's Vet essentials",
    name: "Multi-benefit + Senior Health medium&large breed",
    energy_kcal_kg: 3819.0,
    protein_pct: 21.0,
    rpc: 56.0,
    phosphorus_pct: 0.61,
    p_g_mcal: 1.6,
    rpp: "35",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 80,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Proplan",
    name: "Small&mini Adult 9+ Age defense",
    energy_kcal_kg: 3859.0,
    protein_pct: 29.0,
    rpc: 75.0,
    phosphorus_pct: 0.93,
    p_g_mcal: 2.4,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 81,
    species: "dog",
    type: "dry",
    gamme: "Senior",
    brand: "Proplan",
    name: "Medium&large 7+ Age defense",
    energy_kcal_kg: 3859.0,
    protein_pct: 29.0,
    rpc: 75.0,
    phosphorus_pct: 0.93,
    p_g_mcal: 2.4,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 82,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Early renal",
    energy_kcal_kg: 4000.0,
    protein_pct: 23.0,
    rpc: 56.0,
    phosphorus_pct: 0.5,
    p_g_mcal: 1.3,
    rpp: "45",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 83,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal",
    energy_kcal_kg: 4000.0,
    protein_pct: 14.0,
    rpc: 35.0,
    phosphorus_pct: 0.2,
    p_g_mcal: 0.5,
    rpp: "70",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 84,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal Special",
    energy_kcal_kg: 3930.0,
    protein_pct: 13.0,
    rpc: 33.0,
    phosphorus_pct: 0.3,
    p_g_mcal: 0.8,
    rpp: "43",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 85,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal Select",
    energy_kcal_kg: 4000.0,
    protein_pct: 13.0,
    rpc: 31.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 86,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Proplan",
    name: "NF Renal",
    energy_kcal_kg: 3770.0,
    protein_pct: 13.0,
    rpc: 34.0,
    phosphorus_pct: 0.4,
    p_g_mcal: 1.1,
    rpp: "33",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 87,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d Early stage",
    energy_kcal_kg: 4100.0,
    protein_pct: 17.0,
    rpc: 41.0,
    phosphorus_pct: 0.32,
    p_g_mcal: 0.8,
    rpp: "52",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 88,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d Kidney Care",
    energy_kcal_kg: 4020.0,
    protein_pct: 14.0,
    rpc: 34.0,
    phosphorus_pct: 0.22,
    p_g_mcal: 0.5,
    rpp: "63",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 89,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d j/d Kidney Care + Mobility",
    energy_kcal_kg: 4090.0,
    protein_pct: 14.0,
    rpc: 34.0,
    phosphorus_pct: 0.27,
    p_g_mcal: 0.7,
    rpp: "52",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 90,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Virbac",
    name: "K Kidney support",
    energy_kcal_kg: 3910.0,
    protein_pct: 21.0,
    rpc: 52.0,
    phosphorus_pct: 0.4,
    p_g_mcal: 1.0,
    rpp: "51",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 91,
    species: "dog",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Specific",
    name: "CKD Heart and kidney support",
    energy_kcal_kg: 3990.0,
    protein_pct: 14.0,
    rpc: 34.0,
    phosphorus_pct: 0.26,
    p_g_mcal: 0.7,
    rpp: "52",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 92,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Virbac",
    name: "W1 Weight loss & diabetes",
    energy_kcal_kg: 2740.0,
    protein_pct: 34.0,
    rpc: 124.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 3.3,
    rpp: "38",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 93,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Virbac",
    name: "W2 Weight loss & control",
    energy_kcal_kg: 3090.0,
    protein_pct: 34.0,
    rpc: 110.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.3,
    rpp: "49",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 94,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Royal Canin",
    name: "Satiety weight management",
    energy_kcal_kg: 2614.0,
    protein_pct: 30.0,
    rpc: 115.0,
    phosphorus_pct: 0.71,
    p_g_mcal: 2.7,
    rpp: "42",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 95,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Royal Canin",
    name: "Satiety weight management small dog",
    energy_kcal_kg: 2685.0,
    protein_pct: 30.0,
    rpc: 112.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.6,
    rpp: "43",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 96,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Specific",
    name: "CRD-1 Weight reduction",
    energy_kcal_kg: 2740.0,
    protein_pct: 30.0,
    rpc: 108.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.6,
    rpp: "42",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 97,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Specific",
    name: "CRD-2 Weight control",
    energy_kcal_kg: 3170.0,
    protein_pct: 24.0,
    rpc: 76.0,
    phosphorus_pct: 0.73,
    p_g_mcal: 2.3,
    rpp: "33",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 98,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Hill's",
    name: "r/d weight loss",
    energy_kcal_kg: 3000.0,
    protein_pct: 31.0,
    rpc: 104.0,
    phosphorus_pct: 0.61,
    p_g_mcal: 2.0,
    rpp: "51",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 99,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Hill's",
    name: "Metabolic",
    energy_kcal_kg: 2960.0,
    protein_pct: 25.0,
    rpc: 86.0,
    phosphorus_pct: 0.68,
    p_g_mcal: 2.3,
    rpp: "37",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 100,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Hill's",
    name: "Metabolic Mini",
    energy_kcal_kg: 2960.0,
    protein_pct: 25.0,
    rpc: 86.0,
    phosphorus_pct: 0.62,
    p_g_mcal: 2.1,
    rpp: "41",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 101,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Hill's",
    name: "Metabolic + mobility",
    energy_kcal_kg: 2930.0,
    protein_pct: 25.0,
    rpc: 85.0,
    phosphorus_pct: 0.55,
    p_g_mcal: 1.9,
    rpp: "45",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 102,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Hill's",
    name: "Metabolic + mobility Mini",
    energy_kcal_kg: 2940.0,
    protein_pct: 25.0,
    rpc: 84.0,
    phosphorus_pct: 0.54,
    p_g_mcal: 1.8,
    rpp: "46",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 103,
    species: "dog",
    type: "dry",
    gamme: "Surpoids",
    brand: "Proplan",
    name: "OM Obesity",
    energy_kcal_kg: 2960.0,
    protein_pct: 29.0,
    rpc: 98.0,
    phosphorus_pct: 0.87,
    p_g_mcal: 2.9,
    rpp: "33",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 104,
    species: "dog",
    type: "dry",
    gamme: "Urinaire",
    brand: "Virbac",
    name: "U Dissolution & prevention",
    energy_kcal_kg: 3740.0,
    protein_pct: 34.0,
    rpc: 91.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.6,
    rpp: "57",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 105,
    species: "dog",
    type: "dry",
    gamme: "Urinaire",
    brand: "Royal Canin",
    name: "Urinary S/O",
    energy_kcal_kg: 3930.0,
    protein_pct: 18.0,
    rpc: 46.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 106,
    species: "dog",
    type: "dry",
    gamme: "Urinaire",
    brand: "Specific",
    name: "CCD Struvite management",
    energy_kcal_kg: 4100.0,
    protein_pct: 21.0,
    rpc: 51.0,
    phosphorus_pct: 0.39,
    p_g_mcal: 1.0,
    rpp: "54",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 107,
    species: "dog",
    type: "dry",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "c/d Urinary Care",
    energy_kcal_kg: 3960.0,
    protein_pct: 20.0,
    rpc: 51.0,
    phosphorus_pct: 0.48,
    p_g_mcal: 1.2,
    rpp: "42",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 108,
    species: "dog",
    type: "dry",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "Urinary + Metabolic",
    energy_kcal_kg: 2950.0,
    protein_pct: 26.0,
    rpc: 87.0,
    phosphorus_pct: 0.53,
    p_g_mcal: 1.8,
    rpp: "48",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 109,
    species: "dog",
    type: "dry",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "u/d Urinary care",
    energy_kcal_kg: 4100.0,
    protein_pct: 10.0,
    rpc: 24.0,
    phosphorus_pct: 0.17,
    p_g_mcal: 0.4,
    rpp: "59",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 110,
    species: "dog",
    type: "dry",
    gamme: "Urinaire",
    brand: "Proplan",
    name: "UR Urinary",
    energy_kcal_kg: 4000.0,
    protein_pct: 22.0,
    rpc: 55.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 1.8,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 111,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Virbac",
    name: "G Digestive support",
    energy_kcal_kg: 3840.0,
    protein_pct: 34.0,
    rpc: 89.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 2.1,
    rpp: "43",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 112,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal puppy",
    energy_kcal_kg: 4240.0,
    protein_pct: 25.0,
    rpc: 59.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.4,
    rpp: "25",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 113,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal",
    energy_kcal_kg: 4120.0,
    protein_pct: 25.0,
    rpc: 61.0,
    phosphorus_pct: 0.99,
    p_g_mcal: 2.4,
    rpp: "25",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 114,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal moderate calorie",
    energy_kcal_kg: 3670.0,
    protein_pct: 23.0,
    rpc: 63.0,
    phosphorus_pct: 0.89,
    p_g_mcal: 2.4,
    rpp: "26",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 115,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal low fat",
    energy_kcal_kg: 3520.0,
    protein_pct: 22.0,
    rpc: 63.0,
    phosphorus_pct: 0.83,
    p_g_mcal: 2.4,
    rpp: "27",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 116,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal High fibre",
    energy_kcal_kg: 3220.0,
    protein_pct: null,
    rpc: 0.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 117,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Specific",
    name: "CID Digestive support",
    energy_kcal_kg: 3780.0,
    protein_pct: 25.0,
    rpc: 66.0,
    phosphorus_pct: 0.85,
    p_g_mcal: 2.2,
    rpp: "29",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 118,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Specific",
    name: "CID Digestive support low fat",
    energy_kcal_kg: 3270.0,
    protein_pct: 23.0,
    rpc: 70.0,
    phosphorus_pct: 0.51,
    p_g_mcal: 1.6,
    rpp: "45",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 119,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Hill's",
    name: "i/d Digestive Care",
    energy_kcal_kg: 3780.0,
    protein_pct: 23.0,
    rpc: 62.0,
    phosphorus_pct: 0.71,
    p_g_mcal: 1.9,
    rpp: "33",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 120,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Hill's",
    name: "Gastrointestinal Biome",
    energy_kcal_kg: 3460.0,
    protein_pct: 21.0,
    rpc: 62.0,
    phosphorus_pct: 0.66,
    p_g_mcal: 1.9,
    rpp: "32",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 121,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Hill's",
    name: "Gastrointestinal Biome mini",
    energy_kcal_kg: 3460.0,
    protein_pct: 21.0,
    rpc: 62.0,
    phosphorus_pct: 0.66,
    p_g_mcal: 1.9,
    rpp: "32",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 122,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Hill's",
    name: "i/d Stress Mini",
    energy_kcal_kg: 3585.0,
    protein_pct: 24.0,
    rpc: 67.0,
    phosphorus_pct: 0.58,
    p_g_mcal: 1.6,
    rpp: "41",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 123,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Hill's",
    name: "i/d Low Fat",
    energy_kcal_kg: 3590.0,
    protein_pct: 24.0,
    rpc: 66.0,
    phosphorus_pct: 0.59,
    p_g_mcal: 1.6,
    rpp: "40",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 124,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Hill's",
    name: "i/d Sensitive",
    energy_kcal_kg: 4040.0,
    protein_pct: 24.0,
    rpc: 59.0,
    phosphorus_pct: 0.76,
    p_g_mcal: 1.9,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 125,
    species: "dog",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Proplan",
    name: "EN Gastro-intestinal",
    energy_kcal_kg: 3700.0,
    protein_pct: 24.0,
    rpc: 65.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 2.2,
    rpp: "30",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 126,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Virbac",
    name: "A2 Hypoallergy food intolerance",
    energy_kcal_kg: 3770.0,
    protein_pct: 24.0,
    rpc: 64.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 1.9,
    rpp: "34",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 127,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Anallergenic",
    energy_kcal_kg: 3930.0,
    protein_pct: 18.0,
    rpc: 46.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 2.0,
    rpp: "23",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 128,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Hypoallergenic",
    energy_kcal_kg: 4130.0,
    protein_pct: 21.0,
    rpc: 51.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 1.9,
    rpp: "26",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 129,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Hypoallergenic small dog",
    energy_kcal_kg: 3940.0,
    protein_pct: 24.0,
    rpc: 61.0,
    phosphorus_pct: 0.61,
    p_g_mcal: 1.5,
    rpp: "39",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 130,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Hypoallergenic moderate calorie",
    energy_kcal_kg: 3770.0,
    protein_pct: 23.0,
    rpc: 61.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.6,
    rpp: "38",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 131,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Specific",
    name: "CDD Food allergen management",
    energy_kcal_kg: 3790.0,
    protein_pct: 16.0,
    rpc: 43.0,
    phosphorus_pct: 0.54,
    p_g_mcal: 1.4,
    rpp: "30",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 132,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Specific",
    name: "CDD-HY Food allergen management",
    energy_kcal_kg: 3710.0,
    protein_pct: 23.0,
    rpc: 61.0,
    phosphorus_pct: 0.85,
    p_g_mcal: 2.3,
    rpp: "27",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 133,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Specific",
    name: "COD-HY Allergen management plus",
    energy_kcal_kg: 3630.0,
    protein_pct: 23.0,
    rpc: 63.0,
    phosphorus_pct: 0.88,
    p_g_mcal: 2.4,
    rpp: "26",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 134,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Hill's",
    name: "z/d Food Sensitivities",
    energy_kcal_kg: 3540.0,
    protein_pct: 18.0,
    rpc: 50.0,
    phosphorus_pct: 0.51,
    p_g_mcal: 1.4,
    rpp: "35",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 135,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Hill's",
    name: "d/d Food Sensitivities",
    energy_kcal_kg: 3920.0,
    protein_pct: 15.0,
    rpc: 39.0,
    phosphorus_pct: 0.61,
    p_g_mcal: 1.6,
    rpp: "25",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 136,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Hill's",
    name: "i/d Sensitive Digestive care",
    energy_kcal_kg: 4040.0,
    protein_pct: 24.0,
    rpc: 59.0,
    phosphorus_pct: 0.76,
    p_g_mcal: 1.9,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 137,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Hill's",
    name: "Derm Complete",
    energy_kcal_kg: 4110.0,
    protein_pct: 16.0,
    rpc: 38.0,
    phosphorus_pct: 0.55,
    p_g_mcal: 1.3,
    rpp: "28",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 138,
    species: "dog",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Proplan",
    name: "HA Hypoallergenic",
    energy_kcal_kg: 3700.0,
    protein_pct: 21.0,
    rpc: 57.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.4,
    rpp: "23",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 139,
    species: "dog",
    type: "dry",
    gamme: "Dermatologie",
    brand: "Virbac",
    name: "D1 Dermatology support",
    energy_kcal_kg: 3750.0,
    protein_pct: 34.0,
    rpc: 91.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 2.1,
    rpp: "43",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 140,
    species: "dog",
    type: "dry",
    gamme: "Dermatologie",
    brand: "Proplan",
    name: "DRM Dermatosis",
    energy_kcal_kg: 4000.0,
    protein_pct: 30.0,
    rpc: 75.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.5,
    rpp: "30",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 141,
    species: "dog",
    type: "dry",
    gamme: "Dermatologie",
    brand: "Hill's",
    name: "Derm Defense",
    energy_kcal_kg: 3980.0,
    protein_pct: 21.0,
    rpc: 52.0,
    phosphorus_pct: 0.53,
    p_g_mcal: 1.3,
    rpp: "39",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 142,
    species: "dog",
    type: "dry",
    gamme: "Dermatologie",
    brand: "Hill's",
    name: "Derm Complete",
    energy_kcal_kg: 4110.0,
    protein_pct: 16.0,
    rpc: 38.0,
    phosphorus_pct: 0.55,
    p_g_mcal: 1.3,
    rpp: "28",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 143,
    species: "dog",
    type: "dry",
    gamme: "Arthrose",
    brand: "Virbac",
    name: "Joint mobility",
    energy_kcal_kg: 3350.0,
    protein_pct: 34.0,
    rpc: 101.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.1,
    rpp: "49",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 144,
    species: "dog",
    type: "dry",
    gamme: "Arthrose",
    brand: "Royal Canin",
    name: "Mobility support",
    energy_kcal_kg: 3700.0,
    protein_pct: 25.0,
    rpc: 68.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 145,
    species: "dog",
    type: "dry",
    gamme: "Arthrose",
    brand: "Proplan",
    name: "JM Joint Mobility",
    energy_kcal_kg: 3720.0,
    protein_pct: 30.0,
    rpc: 81.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.4,
    rpp: "33",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 146,
    species: "dog",
    type: "dry",
    gamme: "Arthrose",
    brand: "Specific",
    name: "CJD Joint support",
    energy_kcal_kg: 3350.0,
    protein_pct: 21.0,
    rpc: 63.0,
    phosphorus_pct: 0.59,
    p_g_mcal: 1.8,
    rpp: "36",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 147,
    species: "dog",
    type: "dry",
    gamme: "Arthrose",
    brand: "Hill's",
    name: "j/d Mobility",
    energy_kcal_kg: 3650.0,
    protein_pct: 18.0,
    rpc: 48.0,
    phosphorus_pct: 0.49,
    p_g_mcal: 1.3,
    rpp: "36",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 148,
    species: "dog",
    type: "dry",
    gamme: "Arthrose",
    brand: "Hill's",
    name: "j/d Mobility reduced calorie",
    energy_kcal_kg: 3325.0,
    protein_pct: 22.0,
    rpc: 65.0,
    phosphorus_pct: 0.52,
    p_g_mcal: 1.6,
    rpp: "41",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 149,
    species: "dog",
    type: "dry",
    gamme: "Arthrose",
    brand: "Hill's",
    name: "Metabolic + Mobility",
    energy_kcal_kg: 2930.0,
    protein_pct: 25.0,
    rpc: 85.0,
    phosphorus_pct: 0.55,
    p_g_mcal: 1.9,
    rpp: "45",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 150,
    species: "dog",
    type: "dry",
    gamme: "Arthrose",
    brand: "Hill's",
    name: "Metabolic + Mobility Mini",
    energy_kcal_kg: 2940.0,
    protein_pct: 25.0,
    rpc: 85.0,
    phosphorus_pct: 0.54,
    p_g_mcal: 1.8,
    rpp: "46",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 151,
    species: "dog",
    type: "dry",
    gamme: "Arthrose",
    brand: "Hill's",
    name: "k/d j/d Kidney + Mobility",
    energy_kcal_kg: 4087.0,
    protein_pct: 14.0,
    rpc: 34.0,
    phosphorus_pct: 0.27,
    p_g_mcal: 0.7,
    rpp: "52",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 152,
    species: "dog",
    type: "dry",
    gamme: "Bucco-dentaire",
    brand: "Royal Canin",
    name: "Dental medium & large",
    energy_kcal_kg: 3930.0,
    protein_pct: 22.0,
    rpc: 56.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.5,
    rpp: "37",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 153,
    species: "dog",
    type: "dry",
    gamme: "Bucco-dentaire",
    brand: "Royal Canin",
    name: "Dental small dog",
    energy_kcal_kg: 3870.0,
    protein_pct: 22.0,
    rpc: 57.0,
    phosphorus_pct: null,
    p_g_mcal: 0.0,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 154,
    species: "dog",
    type: "dry",
    gamme: "Bucco-dentaire",
    brand: "Hill's",
    name: "t/d Dental Care",
    energy_kcal_kg: 3410.0,
    protein_pct: 16.0,
    rpc: 47.0,
    phosphorus_pct: 0.41,
    p_g_mcal: 1.2,
    rpp: "39",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 155,
    species: "dog",
    type: "dry",
    gamme: "Bucco-dentaire",
    brand: "Hill's",
    name: "t/d Mini",
    energy_kcal_kg: 3410.0,
    protein_pct: 16.0,
    rpc: 47.0,
    phosphorus_pct: 0.41,
    p_g_mcal: 1.2,
    rpp: "39",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 156,
    species: "dog",
    type: "dry",
    gamme: "Stress",
    brand: "Royal Canin",
    name: "Calm small dogs",
    energy_kcal_kg: 3940.0,
    protein_pct: 25.0,
    rpc: 63.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 2.0,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 157,
    species: "dog",
    type: "dry",
    gamme: "Stress",
    brand: "Hill's",
    name: "Multi-benefit + Calm small&mini adult",
    energy_kcal_kg: 3885.0,
    protein_pct: 23.0,
    rpc: 59.0,
    phosphorus_pct: 0.68,
    p_g_mcal: 1.8,
    rpp: "34",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 158,
    species: "dog",
    type: "dry",
    gamme: "Cardiaque",
    brand: "Royal Canin",
    name: "Cardiac",
    energy_kcal_kg: 3940.0,
    protein_pct: 26.0,
    rpc: 66.0,
    phosphorus_pct: 0.55,
    p_g_mcal: 1.4,
    rpp: "47",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 159,
    species: "dog",
    type: "dry",
    gamme: "Cardiaque",
    brand: "Specific",
    name: "CKD Heart and kidney support",
    energy_kcal_kg: 3990.0,
    protein_pct: 14.0,
    rpc: 34.0,
    phosphorus_pct: 0.26,
    p_g_mcal: 0.7,
    rpp: "52",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 160,
    species: "dog",
    type: "dry",
    gamme: "Cardiaque",
    brand: "Proplan",
    name: "Cardiocare",
    energy_kcal_kg: 3690.0,
    protein_pct: 27.0,
    rpc: 72.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 161,
    species: "dog",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Proplan",
    name: "DM Diabetes",
    energy_kcal_kg: 3420.0,
    protein_pct: 37.0,
    rpc: 108.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.9,
    rpp: "37",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 162,
    species: "dog",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Specific",
    name: "CED Endocrine support",
    energy_kcal_kg: 3360.0,
    protein_pct: 38.0,
    rpc: 113.0,
    phosphorus_pct: 0.5,
    p_g_mcal: 1.5,
    rpp: "76",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 163,
    species: "dog",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Hill's",
    name: "w/d diabetes care",
    energy_kcal_kg: 3016.0,
    protein_pct: 21.0,
    rpc: 69.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 2.0,
    rpp: "35",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 164,
    species: "dog",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Royal Canin",
    name: "Diabetic",
    energy_kcal_kg: 3500.0,
    protein_pct: 37.0,
    rpc: 106.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.0,
    rpp: "53",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 165,
    species: "dog",
    type: "dry",
    gamme: "Neuro",
    brand: "Proplan",
    name: "NC Neurocare",
    energy_kcal_kg: 3920.0,
    protein_pct: 30.0,
    rpc: 77.0,
    phosphorus_pct: 1.2,
    p_g_mcal: 3.1,
    rpp: "25",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 166,
    species: "dog",
    type: "dry",
    gamme: "H\u00e9patique",
    brand: "Royal Canin",
    name: "Hepatic",
    energy_kcal_kg: 3930.0,
    protein_pct: 16.0,
    rpc: 41.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 167,
    species: "dog",
    type: "dry",
    gamme: "H\u00e9patique",
    brand: "Proplan",
    name: "HP Hepatic",
    energy_kcal_kg: 3920.0,
    protein_pct: 19.0,
    rpc: 48.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 168,
    species: "dog",
    type: "dry",
    gamme: "Sans c\u00e9r\u00e9ale",
    brand: "Hill's",
    name: "No grain",
    energy_kcal_kg: 3890.0,
    protein_pct: 22.0,
    rpc: 56.0,
    phosphorus_pct: 0.69,
    p_g_mcal: 1.8,
    rpp: "32",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 169,
    species: "dog",
    type: "dry",
    gamme: "Sans c\u00e9r\u00e9ale",
    brand: "Proplan",
    name: "Small&mini Adult Sensitive digestion Grain free",
    energy_kcal_kg: 3863.0,
    protein_pct: 30.0,
    rpc: 78.0,
    phosphorus_pct: 0.91,
    p_g_mcal: 2.4,
    rpp: "33",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 170,
    species: "dog",
    type: "dry",
    gamme: "Sans c\u00e9r\u00e9ale",
    brand: "Proplan",
    name: "Medium&large Adult sensitive digestion Grain free",
    energy_kcal_kg: 3811.0,
    protein_pct: 28.0,
    rpc: 73.0,
    phosphorus_pct: 0.82,
    p_g_mcal: 2.2,
    rpp: "34",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 171,
    species: "dog",
    type: "dry",
    gamme: "Autres",
    brand: "Specifc",
    name: "COD Skin function support",
    energy_kcal_kg: 4130.0,
    protein_pct: 26.0,
    rpc: 63.0,
    phosphorus_pct: 0.72,
    p_g_mcal: 1.7,
    rpp: "36",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 172,
    species: "dog",
    type: "dry",
    gamme: "Autres",
    brand: "Specifc",
    name: "CAD Active",
    energy_kcal_kg: 4410.0,
    protein_pct: 29.0,
    rpc: 66.0,
    phosphorus_pct: 1.05,
    p_g_mcal: 2.4,
    rpp: "28",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 173,
    species: "dog",
    type: "dry",
    gamme: "Autres",
    brand: "Specifc",
    name: "Adult Organic",
    energy_kcal_kg: 3560.0,
    protein_pct: 21.0,
    rpc: 59.0,
    phosphorus_pct: 0.65,
    p_g_mcal: 1.8,
    rpp: "32",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 174,
    species: "dog",
    type: "dry",
    gamme: "Autres",
    brand: "Hill's",
    name: "On-Care",
    energy_kcal_kg: 4240.0,
    protein_pct: 25.0,
    rpc: 58.0,
    phosphorus_pct: 0.61,
    p_g_mcal: 1.4,
    rpp: "41",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 175,
    species: "dog",
    type: "dry",
    gamme: "Multifunction",
    brand: "Royal Canin",
    name: "Gastrointestinal Low fat + Hypoallergenic",
    energy_kcal_kg: 3508.0,
    protein_pct: null,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 176,
    species: "dog",
    type: "dry",
    gamme: "Multifunction",
    brand: "Royal Canin",
    name: "Renal + Hypoallergenic",
    energy_kcal_kg: 4031.0,
    protein_pct: null,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 177,
    species: "dog",
    type: "dry",
    gamme: "Multifunction",
    brand: "Royal Canin",
    name: "Urinary + Hypoallergenic",
    energy_kcal_kg: 3710.0,
    protein_pct: null,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 178,
    species: "dog",
    type: "dry",
    gamme: "Multifunction",
    brand: "Royal Canin",
    name: "Urinary + Satiety",
    energy_kcal_kg: 2661.0,
    protein_pct: null,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 179,
    species: "dog",
    type: "wet",
    gamme: "Chiot",
    brand: "Royal Canin",
    name: "Starter mother and baby dog Sauce",
    energy_kcal_kg: 1000.0,
    protein_pct: 10.0,
    rpc: 100.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 180,
    species: "dog",
    type: "wet",
    gamme: "Chiot",
    brand: "Royal Canin",
    name: "X-small/Mini/Medium Puppy Sauce",
    energy_kcal_kg: 950.0,
    protein_pct: 8.0,
    rpc: 84.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 181,
    species: "dog",
    type: "wet",
    gamme: "Chiot",
    brand: "Royal Canin",
    name: "Maxi Puppy sauce",
    energy_kcal_kg: 885.0,
    protein_pct: 8.3,
    rpc: 94.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 182,
    species: "dog",
    type: "wet",
    gamme: "Chiot",
    brand: "Specific",
    name: "CPW Puppy all breeds",
    energy_kcal_kg: 1500.0,
    protein_pct: 13.0,
    rpc: 87.0,
    phosphorus_pct: 0.34,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.38,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 183,
    species: "dog",
    type: "wet",
    gamme: "Adulte",
    brand: "Royal Canin",
    name: "Adult Sauce",
    energy_kcal_kg: 881.0,
    protein_pct: 7.6,
    rpc: 86.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 184,
    species: "dog",
    type: "wet",
    gamme: "Adulte",
    brand: "Specific",
    name: "CXW Adult all breeds",
    energy_kcal_kg: 940.0,
    protein_pct: 9.0,
    rpc: 96.0,
    phosphorus_pct: 0.15,
    p_g_mcal: 1.6,
    rpp: "60",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 185,
    species: "dog",
    type: "wet",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Neutered adult sauce",
    energy_kcal_kg: 737.0,
    protein_pct: 8.5,
    rpc: 115.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 186,
    species: "dog",
    type: "wet",
    gamme: "Senior",
    brand: "Royal Canin",
    name: "Mature consult mousse",
    energy_kcal_kg: 950.0,
    protein_pct: 9.4,
    rpc: 99.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 187,
    species: "dog",
    type: "wet",
    gamme: "Senior",
    brand: "Specific",
    name: "CGW Senior all breeds",
    energy_kcal_kg: 810.0,
    protein_pct: 4.8,
    rpc: 59.0,
    phosphorus_pct: 0.11,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 188,
    species: "dog",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Early Renal",
    energy_kcal_kg: 954.0,
    protein_pct: 5.5,
    rpc: 58.0,
    phosphorus_pct: 0.13,
    p_g_mcal: 1.4,
    rpp: "42",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 189,
    species: "dog",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal sachet",
    energy_kcal_kg: 960.0,
    protein_pct: 3.7,
    rpc: 39.0,
    phosphorus_pct: 0.08,
    p_g_mcal: 0.8,
    rpp: "46",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 190,
    species: "dog",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal bo\u00eete",
    energy_kcal_kg: 1586.0,
    protein_pct: 5.4,
    rpc: 34.0,
    phosphorus_pct: 0.11,
    p_g_mcal: 0.7,
    rpp: "49",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 191,
    species: "dog",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal Special bo\u00eete",
    energy_kcal_kg: 1600.0,
    protein_pct: 6.0,
    rpc: 38.0,
    phosphorus_pct: 0.13,
    p_g_mcal: 0.8,
    rpp: "46",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 192,
    species: "dog",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Proplan",
    name: "NF Renal",
    energy_kcal_kg: 1300.0,
    protein_pct: 6.0,
    rpc: 46.0,
    phosphorus_pct: 0.12,
    p_g_mcal: 0.9,
    rpp: "50",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 193,
    species: "dog",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Specific",
    name: "CKW Heart and kidney support",
    energy_kcal_kg: 1100.0,
    protein_pct: 4.5,
    rpc: null,
    phosphorus_pct: 0.07,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 194,
    species: "dog",
    type: "wet",
    gamme: "Surpoids",
    brand: "Royal Canin",
    name: "Satiety weight management",
    energy_kcal_kg: 579.0,
    protein_pct: 8.0,
    rpc: 138.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 195,
    species: "dog",
    type: "wet",
    gamme: "Surpoids",
    brand: "Specific",
    name: "CRW-1 Weight reduction",
    energy_kcal_kg: 660.0,
    protein_pct: 7.1,
    rpc: 108.0,
    phosphorus_pct: 0.16,
    p_g_mcal: 2.4,
    rpp: "44",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 196,
    species: "dog",
    type: "wet",
    gamme: "Surpoids",
    brand: "Proplan",
    name: "OM Obesity",
    energy_kcal_kg: 570.0,
    protein_pct: 8.7,
    rpc: 153.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 197,
    species: "dog",
    type: "wet",
    gamme: "Urinaire",
    brand: "Royal Canin",
    name: "Urinary S/O sachet",
    energy_kcal_kg: 930.0,
    protein_pct: 8.0,
    rpc: null,
    phosphorus_pct: 0.14,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 198,
    species: "dog",
    type: "wet",
    gamme: "Urinaire",
    brand: "Royal Canin",
    name: "Urinary S/O bo\u00eete",
    energy_kcal_kg: 960.0,
    protein_pct: 8.0,
    rpc: null,
    phosphorus_pct: 0.2,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 199,
    species: "dog",
    type: "wet",
    gamme: "Urinaire",
    brand: "Royal Canin",
    name: "Urinary moderate calorie",
    energy_kcal_kg: 822.0,
    protein_pct: 8.0,
    rpc: null,
    phosphorus_pct: 0.13,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 200,
    species: "dog",
    type: "wet",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal",
    energy_kcal_kg: 1111.0,
    protein_pct: 8.9,
    rpc: 80.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 201,
    species: "dog",
    type: "wet",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal low fat",
    energy_kcal_kg: 940.0,
    protein_pct: 8.1,
    rpc: 86.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 202,
    species: "dog",
    type: "wet",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal high fibre",
    energy_kcal_kg: 958.0,
    protein_pct: 7.4,
    rpc: 77.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 203,
    species: "dog",
    type: "wet",
    gamme: "Gastro-intestinal",
    brand: "Specific",
    name: "CIW Digestive support",
    energy_kcal_kg: 1240.0,
    protein_pct: 7.5,
    rpc: 60.0,
    phosphorus_pct: 0.28,
    p_g_mcal: 2.3,
    rpp: "27",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 204,
    species: "dog",
    type: "wet",
    gamme: "Gastro-intestinal",
    brand: "Specific",
    name: "CIW-LF Digestive support low fat",
    energy_kcal_kg: 1090.0,
    protein_pct: 8.0,
    rpc: 73.0,
    phosphorus_pct: 0.19,
    p_g_mcal: 1.7,
    rpp: "42",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 205,
    species: "dog",
    type: "wet",
    gamme: "Gastro-intestinal",
    brand: "Proplan",
    name: "EN Gastro-intestinal",
    energy_kcal_kg: 1100.0,
    protein_pct: 8.0,
    rpc: 73.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 206,
    species: "dog",
    type: "wet",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Hypoallergenic",
    energy_kcal_kg: 913.0,
    protein_pct: 7.0,
    rpc: 77.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 207,
    species: "dog",
    type: "wet",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Sensitivity control chicken with rice",
    energy_kcal_kg: 1210.0,
    protein_pct: 9.5,
    rpc: 79.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 208,
    species: "dog",
    type: "wet",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Sensitivity control duck with rice",
    energy_kcal_kg: 1420.0,
    protein_pct: 9.0,
    rpc: 63.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 209,
    species: "dog",
    type: "wet",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Specific",
    name: "CDW Food allergen management",
    energy_kcal_kg: 1350.0,
    protein_pct: 7.6,
    rpc: null,
    phosphorus_pct: 0.18,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 210,
    species: "dog",
    type: "wet",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Specific",
    name: "COW-HY Allergen management plus",
    energy_kcal_kg: 1320.0,
    protein_pct: 8.2,
    rpc: null,
    phosphorus_pct: 0.3,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 211,
    species: "dog",
    type: "wet",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Proplan",
    name: "HA Hypoallergenic",
    energy_kcal_kg: 940.0,
    protein_pct: 6.2,
    rpc: 66.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 212,
    species: "dog",
    type: "wet",
    gamme: "Cardiaque",
    brand: "Royal Canin",
    name: "Cardiac",
    energy_kcal_kg: 1246.0,
    protein_pct: 8.1,
    rpc: 65.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 213,
    species: "dog",
    type: "wet",
    gamme: "Cardiaque",
    brand: "Specific",
    name: "CKW Heart and kidney support",
    energy_kcal_kg: 1100.0,
    protein_pct: 4.5,
    rpc: 41.0,
    phosphorus_pct: 0.07,
    p_g_mcal: 0.6,
    rpp: "64",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 214,
    species: "dog",
    type: "wet",
    gamme: "Diab\u00e8te",
    brand: "Royal Canin",
    name: "Diabetic special",
    energy_kcal_kg: 771.0,
    protein_pct: 9.0,
    rpc: 117.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 215,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Proplan",
    name: "CN Convalescence",
    energy_kcal_kg: 1120.0,
    protein_pct: 10.9,
    rpc: 97.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 216,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Specifc",
    name: "Intensive support (p\u00e2t\u00e9e)",
    energy_kcal_kg: 1290.0,
    protein_pct: 12.0,
    rpc: 93.0,
    phosphorus_pct: 0.29,
    p_g_mcal: 2.2,
    rpp: "41",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 217,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Specifc",
    name: "Intensive support (liquide)",
    energy_kcal_kg: 815.0,
    protein_pct: 6.8,
    rpc: 83.0,
    phosphorus_pct: 0.19,
    p_g_mcal: 2.3,
    rpp: "36",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 218,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Specifc",
    name: "Organic fish",
    energy_kcal_kg: 1040.0,
    protein_pct: 7.7,
    rpc: null,
    phosphorus_pct: 0.32,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 219,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Specifc",
    name: "Organic beef",
    energy_kcal_kg: 1020.0,
    protein_pct: 8.6,
    rpc: null,
    phosphorus_pct: 0.25,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 220,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Royal Canin",
    name: "Recovery bo\u00eete",
    energy_kcal_kg: 1183.0,
    protein_pct: 12.7,
    rpc: 107.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 221,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Royal Canin",
    name: "Recovery liquid",
    energy_kcal_kg: 1050.0,
    protein_pct: 8.2,
    rpc: 78.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 222,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Royal Canin",
    name: "Renal liquid",
    energy_kcal_kg: 1500.0,
    protein_pct: 5.0,
    rpc: 33.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 223,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Royal Canin",
    name: "Gastrointestinal high energy liquid",
    energy_kcal_kg: 1470.0,
    protein_pct: 9.0,
    rpc: 61.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 224,
    species: "dog",
    type: "wet",
    gamme: "Autres",
    brand: "Royal Canin",
    name: "Gastrointestinal low fat liquid",
    energy_kcal_kg: 1050.0,
    protein_pct: 9.0,
    rpc: 86.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 225,
    species: "cat",
    type: "dry",
    gamme: "Chaton",
    brand: "Royal Canin",
    name: "Mother and Babycat",
    energy_kcal_kg: 4380.0,
    protein_pct: 34.0,
    rpc: 78.0,
    phosphorus_pct: 1.04,
    p_g_mcal: 2.4,
    rpp: "pas pour l'alim en croissance",
    calcium_pct: 1.22,
    ca_g_mcal: 2.8,
    ca_p_ratio: 1.17,
  },
  {
    id: 226,
    species: "cat",
    type: "dry",
    gamme: "Chaton",
    brand: "Royal Canin",
    name: "Kitten",
    energy_kcal_kg: 4030.0,
    protein_pct: 34.0,
    rpc: 84.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 227,
    species: "cat",
    type: "dry",
    gamme: "Chaton",
    brand: "Virbac",
    name: "Baby pre neutered",
    energy_kcal_kg: 4120.0,
    protein_pct: 36.0,
    rpc: 87.0,
    phosphorus_pct: 1.1,
    p_g_mcal: 2.7,
    rpp: null,
    calcium_pct: 1.2,
    ca_g_mcal: 2.9,
    ca_p_ratio: 1.09,
  },
  {
    id: 228,
    species: "cat",
    type: "dry",
    gamme: "Chaton",
    brand: "Hill's",
    name: "Multi-benefit Kitten",
    energy_kcal_kg: 4040.0,
    protein_pct: 37.0,
    rpc: 92.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: 1.3,
    ca_g_mcal: 3.2,
    ca_p_ratio: 1.3,
  },
  {
    id: 229,
    species: "cat",
    type: "dry",
    gamme: "Chaton",
    brand: "Specific",
    name: "FPD Kitten",
    energy_kcal_kg: 4184.0,
    protein_pct: 40.0,
    rpc: 96.0,
    phosphorus_pct: 0.92,
    p_g_mcal: 2.2,
    rpp: null,
    calcium_pct: 1.1,
    ca_g_mcal: 2.6,
    ca_p_ratio: 1.2,
  },
  {
    id: 230,
    species: "cat",
    type: "dry",
    gamme: "Chaton",
    brand: "Proplan",
    name: "Kitten Healtystart poulet",
    energy_kcal_kg: 4255.0,
    protein_pct: 40.0,
    rpc: 94.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.4,
    rpp: null,
    calcium_pct: 1.3,
    ca_g_mcal: 3.1,
    ca_p_ratio: 1.3,
  },
  {
    id: 231,
    species: "cat",
    type: "dry",
    gamme: "Chaton",
    brand: "Tonivet",
    name: "Chaton",
    energy_kcal_kg: 4200.0,
    protein_pct: 39.0,
    rpc: 93.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.1,
    rpp: null,
    calcium_pct: 1.3,
    ca_g_mcal: 3.1,
    ca_p_ratio: 1.44,
  },
  {
    id: 232,
    species: "cat",
    type: "dry",
    gamme: "Chaton st\u00e9rilis\u00e9",
    brand: "Virbac",
    name: "Junior neutered",
    energy_kcal_kg: 3841.0,
    protein_pct: 45.0,
    rpc: 117.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.6,
    rpp: "pas pour l'alim en croissance",
    calcium_pct: 1.3,
    ca_g_mcal: 3.4,
    ca_p_ratio: 1.3,
  },
  {
    id: 233,
    species: "cat",
    type: "dry",
    gamme: "Chaton st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Cat sterilised kitten",
    energy_kcal_kg: 3420.0,
    protein_pct: 34.0,
    rpc: 99.0,
    phosphorus_pct: 0.95,
    p_g_mcal: 2.8,
    rpp: null,
    calcium_pct: 1.04,
    ca_g_mcal: 3.0,
    ca_p_ratio: 1.09,
  },
  {
    id: 234,
    species: "cat",
    type: "dry",
    gamme: "Chaton st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "Sterilised kitten Optistart saumon",
    energy_kcal_kg: 4070.0,
    protein_pct: 40.0,
    rpc: 98.0,
    phosphorus_pct: 1.17,
    p_g_mcal: 2.9,
    rpp: null,
    calcium_pct: 1.47,
    ca_g_mcal: 3.6,
    ca_p_ratio: 1.26,
  },
  {
    id: 235,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Virbac",
    name: "Neutered & entire",
    energy_kcal_kg: 3841.0,
    protein_pct: 45.0,
    rpc: 117.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.6,
    rpp: "45",
    calcium_pct: 1.3,
    ca_g_mcal: 3.4,
    ca_p_ratio: 1.3,
  },
  {
    id: 236,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Royal Canin",
    name: "Cat Adult",
    energy_kcal_kg: 3860.0,
    protein_pct: 33.0,
    rpc: 85.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.3,
    rpp: "37",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 237,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Specific",
    name: "FXD Adult",
    energy_kcal_kg: 3548.0,
    protein_pct: 32.0,
    rpc: 90.0,
    phosphorus_pct: 0.63,
    p_g_mcal: 1.8,
    rpp: "51",
    calcium_pct: 0.73,
    ca_g_mcal: 2.1,
    ca_p_ratio: 1.16,
  },
  {
    id: 238,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Specific",
    name: "FQD-F Atlantic Sardine",
    energy_kcal_kg: 3675.0,
    protein_pct: 32.0,
    rpc: 87.0,
    phosphorus_pct: 0.78,
    p_g_mcal: 2.1,
    rpp: "41",
    calcium_pct: 0.95,
    ca_g_mcal: 2.6,
    ca_p_ratio: 1.22,
  },
  {
    id: 239,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit Adult",
    energy_kcal_kg: 3856.0,
    protein_pct: 31.0,
    rpc: 81.0,
    phosphorus_pct: 0.67,
    p_g_mcal: 1.7,
    rpp: "46",
    calcium_pct: 0.89,
    ca_g_mcal: 2.3,
    ca_p_ratio: 1.33,
  },
  {
    id: 240,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit + Digestion",
    energy_kcal_kg: 3582.0,
    protein_pct: 32.0,
    rpc: 89.0,
    phosphorus_pct: 0.63,
    p_g_mcal: 1.8,
    rpp: "51",
    calcium_pct: 0.71,
    ca_g_mcal: 2.0,
    ca_p_ratio: 1.13,
  },
  {
    id: 241,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit + Dental",
    energy_kcal_kg: 3756.0,
    protein_pct: 32.0,
    rpc: 84.0,
    phosphorus_pct: 0.58,
    p_g_mcal: 1.5,
    rpp: "54",
    calcium_pct: 0.79,
    ca_g_mcal: 2.1,
    ca_p_ratio: 1.36,
  },
  {
    id: 242,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Adult Delicate digestion agneau/dinde",
    energy_kcal_kg: 4138.0,
    protein_pct: 40.0,
    rpc: 97.0,
    phosphorus_pct: 1.19,
    p_g_mcal: 2.9,
    rpp: "34",
    calcium_pct: 1.37,
    ca_g_mcal: 3.3,
    ca_p_ratio: 1.15,
  },
  {
    id: 243,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Adult Renal Plus poulet",
    energy_kcal_kg: 4255.0,
    protein_pct: 36.0,
    rpc: 85.0,
    phosphorus_pct: 1.21,
    p_g_mcal: 2.8,
    rpp: "30",
    calcium_pct: 1.48,
    ca_g_mcal: 3.5,
    ca_p_ratio: 1.22,
  },
  {
    id: 244,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Adult Vital Functions saumon",
    energy_kcal_kg: 3976.0,
    protein_pct: 36.0,
    rpc: 91.0,
    phosphorus_pct: 1.01,
    p_g_mcal: 2.5,
    rpp: "36",
    calcium_pct: 1.15,
    ca_g_mcal: 2.9,
    ca_p_ratio: 1.14,
  },
  {
    id: 245,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Adult Derma Care saumon",
    energy_kcal_kg: 3830.0,
    protein_pct: 36.0,
    rpc: 94.0,
    phosphorus_pct: 0.92,
    p_g_mcal: 2.4,
    rpp: "39",
    calcium_pct: 1.07,
    ca_g_mcal: 2.8,
    ca_p_ratio: 1.16,
  },
  {
    id: 246,
    species: "cat",
    type: "dry",
    gamme: "Adulte",
    brand: "Tonivet",
    name: "Adulte canard/poulet",
    energy_kcal_kg: 3994.0,
    protein_pct: 38.0,
    rpc: 95.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.3,
    rpp: "42",
    calcium_pct: 1.1,
    ca_g_mcal: 2.8,
    ca_p_ratio: 1.22,
  },
  {
    id: 247,
    species: "cat",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Virbac",
    name: "Neutered",
    energy_kcal_kg: 3525.0,
    protein_pct: 44.5,
    rpc: 126.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.8,
    rpp: "45",
    calcium_pct: 1.3,
    ca_g_mcal: 3.7,
    ca_p_ratio: 1.3,
  },
  {
    id: 248,
    species: "cat",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Cat neutered satiety balance",
    energy_kcal_kg: 3350.0,
    protein_pct: 35.0,
    rpc: 104.0,
    phosphorus_pct: 1.13,
    p_g_mcal: 3.4,
    rpp: "31",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 249,
    species: "cat",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Specific",
    name: "FXD Adult",
    energy_kcal_kg: 3548.0,
    protein_pct: 32.0,
    rpc: 90.0,
    phosphorus_pct: 0.63,
    p_g_mcal: 1.8,
    rpp: "51",
    calcium_pct: 0.73,
    ca_g_mcal: 2.1,
    ca_p_ratio: 1.16,
  },
  {
    id: 250,
    species: "cat",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Specific",
    name: "FQD-F Atlantic Sardine",
    energy_kcal_kg: 3675.0,
    protein_pct: 32.0,
    rpc: 87.0,
    phosphorus_pct: 0.78,
    p_g_mcal: 2.1,
    rpp: "41",
    calcium_pct: 0.95,
    ca_g_mcal: 2.6,
    ca_p_ratio: 1.22,
  },
  {
    id: 251,
    species: "cat",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Hill's",
    name: "Multi-benefit + Weight",
    energy_kcal_kg: 3530.0,
    protein_pct: 37.6,
    rpc: 107.0,
    phosphorus_pct: 0.76,
    p_g_mcal: 2.2,
    rpp: "49",
    calcium_pct: 1.03,
    ca_g_mcal: 2.9,
    ca_p_ratio: 1.36,
  },
  {
    id: 252,
    species: "cat",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "Sterilised Adult Renal Plus saumon/lapin/dinde",
    energy_kcal_kg: 3760.0,
    protein_pct: 41.0,
    rpc: 109.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 2.1,
    rpp: "51",
    calcium_pct: 1.36,
    ca_g_mcal: 3.6,
    ca_p_ratio: 1.7,
  },
  {
    id: 253,
    species: "cat",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "Sterilised Adult Delicate Digestion poulet",
    energy_kcal_kg: 3760.0,
    protein_pct: 41.0,
    rpc: 109.0,
    phosphorus_pct: 1.06,
    p_g_mcal: 2.8,
    rpp: "39",
    calcium_pct: 1.46,
    ca_g_mcal: 3.9,
    ca_p_ratio: 1.38,
  },
  {
    id: 254,
    species: "cat",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "Sterilised Adult Savoury Duo",
    energy_kcal_kg: 3760.0,
    protein_pct: 42.0,
    rpc: 112.0,
    phosphorus_pct: 1.03,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 1.23,
    ca_g_mcal: 3.3,
    ca_p_ratio: 1.19,
  },
  {
    id: 255,
    species: "cat",
    type: "dry",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "Adult Light",
    energy_kcal_kg: 3660.0,
    protein_pct: 38.0,
    rpc: 104.0,
    phosphorus_pct: 0.95,
    p_g_mcal: 2.6,
    rpp: "40",
    calcium_pct: 1.26,
    ca_g_mcal: 3.4,
    ca_p_ratio: 1.33,
  },
  {
    id: 256,
    species: "cat",
    type: "dry",
    gamme: "Senior",
    brand: "Virbac",
    name: "Virbac Senior neutered cat",
    energy_kcal_kg: 3770.0,
    protein_pct: 38.0,
    rpc: 101.0,
    phosphorus_pct: 0.75,
    p_g_mcal: 2.0,
    rpp: "51",
    calcium_pct: 1.1,
    ca_g_mcal: 2.9,
    ca_p_ratio: 1.47,
  },
  {
    id: 257,
    species: "cat",
    type: "dry",
    gamme: "Senior",
    brand: "Royal Canin",
    name: "Mature consult balance",
    energy_kcal_kg: 3520.0,
    protein_pct: 34.0,
    rpc: 97.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 2.3,
    rpp: "43",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 258,
    species: "cat",
    type: "dry",
    gamme: "Senior",
    brand: "Specific",
    name: "FGD",
    energy_kcal_kg: 3920.0,
    protein_pct: 26.0,
    rpc: 66.0,
    phosphorus_pct: 0.47,
    p_g_mcal: 1.2,
    rpp: "55",
    calcium_pct: 0.53,
    ca_g_mcal: 1.4,
    ca_p_ratio: 1.13,
  },
  {
    id: 259,
    species: "cat",
    type: "dry",
    gamme: "Senior",
    brand: "Hill's",
    name: "Multi-benefit + Senior Health",
    energy_kcal_kg: 3850.0,
    protein_pct: 32.0,
    rpc: 82.0,
    phosphorus_pct: 0.66,
    p_g_mcal: 1.7,
    rpp: "48",
    calcium_pct: 0.75,
    ca_g_mcal: 1.9,
    ca_p_ratio: 1.14,
  },
  {
    id: 260,
    species: "cat",
    type: "dry",
    gamme: "Senior",
    brand: "Hill's",
    name: "Multi-benefit + Weight Chat mature",
    energy_kcal_kg: 3530.0,
    protein_pct: 37.0,
    rpc: 103.0,
    phosphorus_pct: 0.62,
    p_g_mcal: 1.8,
    rpp: "59",
    calcium_pct: 0.8,
    ca_g_mcal: 2.3,
    ca_p_ratio: 1.29,
  },
  {
    id: 261,
    species: "cat",
    type: "dry",
    gamme: "Senior",
    brand: "Proplan",
    name: "Sterilised Senior Longevis 7+ Dinde",
    energy_kcal_kg: 3876.0,
    protein_pct: 40.0,
    rpc: 103.0,
    phosphorus_pct: 0.76,
    p_g_mcal: 2.0,
    rpp: "53",
    calcium_pct: 1.22,
    ca_g_mcal: 3.1,
    ca_p_ratio: 1.61,
  },
  {
    id: 262,
    species: "cat",
    type: "dry",
    gamme: "Senior",
    brand: "Proplan",
    name: "Senior Longevis 7+",
    energy_kcal_kg: 4107.0,
    protein_pct: 37.0,
    rpc: 90.0,
    phosphorus_pct: 0.78,
    p_g_mcal: 1.9,
    rpp: "47",
    calcium_pct: 1.12,
    ca_g_mcal: 2.7,
    ca_p_ratio: 1.44,
  },
  {
    id: 263,
    species: "cat",
    type: "dry",
    gamme: "Senior",
    brand: "Tonivet",
    name: "Senior",
    energy_kcal_kg: 4000.0,
    protein_pct: 38.0,
    rpc: 95.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.3,
    rpp: "42",
    calcium_pct: 1.3,
    ca_g_mcal: 3.3,
    ca_p_ratio: 1.44,
  },
  {
    id: 264,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Early Renal",
    energy_kcal_kg: 3717.0,
    protein_pct: 28.0,
    rpc: 75.0,
    phosphorus_pct: 0.5,
    p_g_mcal: 1.3,
    rpp: "56",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 265,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal",
    energy_kcal_kg: 3830.0,
    protein_pct: 28.0,
    rpc: 73.0,
    phosphorus_pct: 0.5,
    p_g_mcal: 1.3,
    rpp: "56",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 266,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal Select",
    energy_kcal_kg: 4021.0,
    protein_pct: 25.0,
    rpc: 61.0,
    phosphorus_pct: 0.41,
    p_g_mcal: 1.0,
    rpp: "60",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 267,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal Special",
    energy_kcal_kg: 3840.0,
    protein_pct: 26.0,
    rpc: 68.0,
    phosphorus_pct: 0.44,
    p_g_mcal: 1.1,
    rpp: "59",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 268,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Proplan",
    name: "Renal Function Early Care",
    energy_kcal_kg: 3790.0,
    protein_pct: 29.0,
    rpc: 77.0,
    phosphorus_pct: 0.35,
    p_g_mcal: 0.9,
    rpp: "83",
    calcium_pct: 0.6,
    ca_g_mcal: 1.6,
    ca_p_ratio: 1.71,
  },
  {
    id: 269,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Proplan",
    name: "Renal Function Advanced Function",
    energy_kcal_kg: 4070.0,
    protein_pct: 28.0,
    rpc: 69.0,
    phosphorus_pct: 0.33,
    p_g_mcal: 0.8,
    rpp: "85",
    calcium_pct: 0.6,
    ca_g_mcal: 1.5,
    ca_p_ratio: 1.82,
  },
  {
    id: 270,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d Kidney care Early stage",
    energy_kcal_kg: 4255.0,
    protein_pct: 32.0,
    rpc: 75.0,
    phosphorus_pct: 0.46,
    p_g_mcal: 1.1,
    rpp: "70",
    calcium_pct: 0.78,
    ca_g_mcal: 1.8,
    ca_p_ratio: 1.7,
  },
  {
    id: 271,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d Kidney care Poulet",
    energy_kcal_kg: 4240.0,
    protein_pct: 28.0,
    rpc: 67.0,
    phosphorus_pct: 0.46,
    p_g_mcal: 1.1,
    rpp: "62",
    calcium_pct: 0.7,
    ca_g_mcal: 1.7,
    ca_p_ratio: 1.52,
  },
  {
    id: 272,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d + Mobility",
    energy_kcal_kg: 4200.0,
    protein_pct: 28.3,
    rpc: 67.0,
    phosphorus_pct: 0.5,
    p_g_mcal: 1.2,
    rpp: "57",
    calcium_pct: 0.66,
    ca_g_mcal: 1.6,
    ca_p_ratio: 1.32,
  },
  {
    id: 273,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Virbac",
    name: "KJ1 Early Kidney & Joint",
    energy_kcal_kg: 3840.0,
    protein_pct: 38.0,
    rpc: 99.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.6,
    rpp: "63",
    calcium_pct: 0.9,
    ca_g_mcal: 2.3,
    ca_p_ratio: 1.5,
  },
  {
    id: 274,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Virbac",
    name: "KJ2 Kidney & Joint",
    energy_kcal_kg: 4120.0,
    protein_pct: 35.0,
    rpc: 85.0,
    phosphorus_pct: 0.55,
    p_g_mcal: 1.3,
    rpp: "64",
    calcium_pct: 1.0,
    ca_g_mcal: 2.4,
    ca_p_ratio: 1.82,
  },
  {
    id: 275,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Virbac",
    name: "KJ3 Advanced Kidney & Joint",
    energy_kcal_kg: 4150.0,
    protein_pct: 30.0,
    rpc: 72.0,
    phosphorus_pct: 0.5,
    p_g_mcal: 1.2,
    rpp: "60",
    calcium_pct: 1.0,
    ca_g_mcal: 2.4,
    ca_p_ratio: 2.0,
  },
  {
    id: 276,
    species: "cat",
    type: "dry",
    gamme: "R\u00e9nal",
    brand: "Specific",
    name: "FKD Kidney Support",
    energy_kcal_kg: 4160.0,
    protein_pct: 23.0,
    rpc: 55.0,
    phosphorus_pct: 0.39,
    p_g_mcal: 0.9,
    rpp: "59",
    calcium_pct: 0.68,
    ca_g_mcal: 1.6,
    ca_p_ratio: 1.74,
  },
  {
    id: 277,
    species: "cat",
    type: "dry",
    gamme: "Surpoids",
    brand: "Virbac",
    name: "W1",
    energy_kcal_kg: 3300.0,
    protein_pct: 44.0,
    rpc: 133.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.1,
    rpp: "63",
    calcium_pct: 1.3,
    ca_g_mcal: 3.9,
    ca_p_ratio: 1.86,
  },
  {
    id: 278,
    species: "cat",
    type: "dry",
    gamme: "Surpoids",
    brand: "Virbac",
    name: "W2",
    energy_kcal_kg: 3417.0,
    protein_pct: 44.0,
    rpc: 129.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.6,
    rpp: "49",
    calcium_pct: 1.3,
    ca_g_mcal: 3.8,
    ca_p_ratio: 1.44,
  },
  {
    id: 279,
    species: "cat",
    type: "dry",
    gamme: "Surpoids",
    brand: "Royal Canin",
    name: "Satiety Weight management",
    energy_kcal_kg: 3020.0,
    protein_pct: 34.0,
    rpc: 113.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 280,
    species: "cat",
    type: "dry",
    gamme: "Surpoids",
    brand: "Specific",
    name: "FRD Weight Reduction",
    energy_kcal_kg: 3050.0,
    protein_pct: 32.0,
    rpc: 106.0,
    phosphorus_pct: 0.65,
    p_g_mcal: 2.1,
    rpp: "50",
    calcium_pct: 1.1,
    ca_g_mcal: 3.6,
    ca_p_ratio: 1.69,
  },
  {
    id: 281,
    species: "cat",
    type: "dry",
    gamme: "Surpoids",
    brand: "Hill's",
    name: "r/d weight loss",
    energy_kcal_kg: 3235.0,
    protein_pct: 37.0,
    rpc: 114.0,
    phosphorus_pct: 0.81,
    p_g_mcal: 2.5,
    rpp: "46",
    calcium_pct: 0.9,
    ca_g_mcal: 2.8,
    ca_p_ratio: 1.11,
  },
  {
    id: 282,
    species: "cat",
    type: "dry",
    gamme: "Surpoids",
    brand: "Hill's",
    name: "Metabolic",
    energy_kcal_kg: 3500.0,
    protein_pct: 38.0,
    rpc: 109.0,
    phosphorus_pct: 0.72,
    p_g_mcal: 2.1,
    rpp: "53",
    calcium_pct: 0.93,
    ca_g_mcal: 2.7,
    ca_p_ratio: 1.29,
  },
  {
    id: 283,
    species: "cat",
    type: "dry",
    gamme: "Surpoids",
    brand: "Proplan",
    name: "OM Ob\u00e9sity",
    energy_kcal_kg: 3430.0,
    protein_pct: 48.0,
    rpc: 140.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 284,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Virbac",
    name: "U1 Dissolution de calculs urinaires",
    energy_kcal_kg: 3970.0,
    protein_pct: 44.0,
    rpc: 111.0,
    phosphorus_pct: 0.65,
    p_g_mcal: 1.6,
    rpp: "68",
    calcium_pct: 0.65,
    ca_g_mcal: 1.6,
    ca_p_ratio: 1.0,
  },
  {
    id: 285,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Virbac",
    name: "U2 Dissolution et pr\u00e9vention",
    energy_kcal_kg: 3743.0,
    protein_pct: 44.0,
    rpc: 118.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 1.9,
    rpp: "63",
    calcium_pct: 0.7,
    ca_g_mcal: 1.9,
    ca_p_ratio: 1.0,
  },
  {
    id: 286,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Virbac",
    name: "U3 Dissolution, pr\u00e9vention des calculs et comportement",
    energy_kcal_kg: 3743.0,
    protein_pct: 44.0,
    rpc: 118.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 1.9,
    rpp: "63",
    calcium_pct: 0.7,
    ca_g_mcal: 1.9,
    ca_p_ratio: 1.0,
  },
  {
    id: 287,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Royal Canin",
    name: "Urinary s/o",
    energy_kcal_kg: 3780.0,
    protein_pct: 35.0,
    rpc: 91.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 1.9,
    rpp: "49",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 288,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Royal Canin",
    name: "Urinary s/o moderate calorie",
    energy_kcal_kg: 3415.0,
    protein_pct: 34.0,
    rpc: 100.0,
    phosphorus_pct: 0.95,
    p_g_mcal: 2.8,
    rpp: "36",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 289,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Specific",
    name: "FCD Crystal Management",
    energy_kcal_kg: 4170.0,
    protein_pct: 32.0,
    rpc: 77.0,
    phosphorus_pct: 0.63,
    p_g_mcal: 1.5,
    rpp: "51",
    calcium_pct: 0.7,
    ca_g_mcal: 1.7,
    ca_p_ratio: 1.11,
  },
  {
    id: 290,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Specific",
    name: "FCD-L Crystal Management Light",
    energy_kcal_kg: 3550.0,
    protein_pct: 32.0,
    rpc: 90.0,
    phosphorus_pct: 0.61,
    p_g_mcal: 1.7,
    rpp: "52",
    calcium_pct: 0.67,
    ca_g_mcal: 1.9,
    ca_p_ratio: 1.1,
  },
  {
    id: 291,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "c/d Urinary Care multicare",
    energy_kcal_kg: 4000.0,
    protein_pct: 32.0,
    rpc: 80.0,
    phosphorus_pct: 0.64,
    p_g_mcal: 1.6,
    rpp: "50",
    calcium_pct: 0.75,
    ca_g_mcal: 1.9,
    ca_p_ratio: 1.17,
  },
  {
    id: 292,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "c/d Urinary care multicare stress",
    energy_kcal_kg: 3990.0,
    protein_pct: 32.0,
    rpc: 80.0,
    phosphorus_pct: 0.67,
    p_g_mcal: 1.7,
    rpp: "48",
    calcium_pct: 0.68,
    ca_g_mcal: 1.7,
    ca_p_ratio: 1.01,
  },
  {
    id: 293,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "c/d Urinary Stress + metabolic",
    energy_kcal_kg: 3485.0,
    protein_pct: 32.0,
    rpc: 92.0,
    phosphorus_pct: 0.67,
    p_g_mcal: 1.9,
    rpp: "48",
    calcium_pct: 0.73,
    ca_g_mcal: 2.1,
    ca_p_ratio: 1.09,
  },
  {
    id: 294,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "s/d Urinary",
    energy_kcal_kg: 4340.0,
    protein_pct: 32.0,
    rpc: 74.0,
    phosphorus_pct: 0.69,
    p_g_mcal: 1.6,
    rpp: "46",
    calcium_pct: 0.87,
    ca_g_mcal: 2.0,
    ca_p_ratio: 1.26,
  },
  {
    id: 295,
    species: "cat",
    type: "dry",
    gamme: "Urinaire",
    brand: "Proplan",
    name: "UR Urinary Poulet/poisson",
    energy_kcal_kg: 3500.0,
    protein_pct: 35.0,
    rpc: 100.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 2.3,
    rpp: "44",
    calcium_pct: 0.9,
    ca_g_mcal: 2.6,
    ca_p_ratio: 1.13,
  },
  {
    id: 296,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Virbac",
    name: "G1 Digestive support",
    energy_kcal_kg: 4180.0,
    protein_pct: 44.0,
    rpc: 105.0,
    phosphorus_pct: 0.8,
    p_g_mcal: 1.9,
    rpp: "55",
    calcium_pct: 1.3,
    ca_g_mcal: 3.1,
    ca_p_ratio: 1.63,
  },
  {
    id: 297,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal",
    energy_kcal_kg: 4000.0,
    protein_pct: 32.0,
    rpc: 80.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 298,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal hairball",
    energy_kcal_kg: 3530.0,
    protein_pct: 36.0,
    rpc: 102.0,
    phosphorus_pct: 1.0,
    p_g_mcal: 2.8,
    rpp: "36",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 299,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal fibre response",
    energy_kcal_kg: 3816.0,
    protein_pct: 31.0,
    rpc: 81.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 300,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal moderate calorie",
    energy_kcal_kg: 3630.0,
    protein_pct: 35.0,
    rpc: 96.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 301,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal kitten",
    energy_kcal_kg: 4240.0,
    protein_pct: 35.0,
    rpc: 83.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 1.25,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 302,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Specific",
    name: "FID Digestive support",
    energy_kcal_kg: 4067.0,
    protein_pct: 32.5,
    rpc: 80.0,
    phosphorus_pct: 0.92,
    p_g_mcal: 2.3,
    rpp: "35",
    calcium_pct: 1.1,
    ca_g_mcal: 2.7,
    ca_p_ratio: 1.2,
  },
  {
    id: 303,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Hill's",
    name: "i/d Digestive care",
    energy_kcal_kg: 4131.0,
    protein_pct: 38.6,
    rpc: 93.0,
    phosphorus_pct: 0.87,
    p_g_mcal: 2.1,
    rpp: "44",
    calcium_pct: 1.1,
    ca_g_mcal: 2.7,
    ca_p_ratio: 1.26,
  },
  {
    id: 304,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Hill's",
    name: "Gastrointestinal Biome",
    energy_kcal_kg: 3880.0,
    protein_pct: 34.4,
    rpc: 89.0,
    phosphorus_pct: 0.62,
    p_g_mcal: 1.6,
    rpp: "55",
    calcium_pct: 0.76,
    ca_g_mcal: 2.0,
    ca_p_ratio: 1.23,
  },
  {
    id: 305,
    species: "cat",
    type: "dry",
    gamme: "Gastro-intestinal",
    brand: "Proplan",
    name: "EN Gastrointestinal",
    energy_kcal_kg: 4150.0,
    protein_pct: 40.0,
    rpc: 96.0,
    phosphorus_pct: 0.71,
    p_g_mcal: 1.7,
    rpp: "56",
    calcium_pct: 1.5,
    ca_g_mcal: 3.6,
    ca_p_ratio: 2.11,
  },
  {
    id: 306,
    species: "cat",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Virbac",
    name: "A2 Hypoallergy",
    energy_kcal_kg: 3895.0,
    protein_pct: 31.0,
    rpc: 80.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 1.8,
    rpp: "44",
    calcium_pct: 0.8,
    ca_g_mcal: 2.1,
    ca_p_ratio: 1.14,
  },
  {
    id: 307,
    species: "cat",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Hypoallergenic",
    energy_kcal_kg: 4000.0,
    protein_pct: 25.5,
    rpc: 64.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 308,
    species: "cat",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Anallergenic",
    energy_kcal_kg: 3820.0,
    protein_pct: 24.6,
    rpc: 64.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 309,
    species: "cat",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Sensitivity Control",
    energy_kcal_kg: 3400.0,
    protein_pct: 27.0,
    rpc: 79.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 310,
    species: "cat",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Specific",
    name: "FDD-HY Food Allergy Management",
    energy_kcal_kg: 3720.0,
    protein_pct: 27.5,
    rpc: 74.0,
    phosphorus_pct: 0.85,
    p_g_mcal: 2.3,
    rpp: "32",
    calcium_pct: 0.96,
    ca_g_mcal: 2.6,
    ca_p_ratio: 1.13,
  },
  {
    id: 311,
    species: "cat",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Specific",
    name: "FOD-HY Allergy Management Plus",
    energy_kcal_kg: 3730.0,
    protein_pct: 27.7,
    rpc: 74.0,
    phosphorus_pct: 0.9,
    p_g_mcal: 2.4,
    rpp: "31",
    calcium_pct: 0.97,
    ca_g_mcal: 2.6,
    ca_p_ratio: 1.08,
  },
  {
    id: 312,
    species: "cat",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Hill's",
    name: "d/d Canard et petits pois",
    energy_kcal_kg: 4000.0,
    protein_pct: 34.5,
    rpc: 86.0,
    phosphorus_pct: 0.65,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.73,
    ca_g_mcal: 1.8,
    ca_p_ratio: 1.12,
  },
  {
    id: 313,
    species: "cat",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Hill's",
    name: "z/d Food Sensitivities",
    energy_kcal_kg: 3917.0,
    protein_pct: 32.0,
    rpc: 82.0,
    phosphorus_pct: 0.62,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.74,
    ca_g_mcal: 1.9,
    ca_p_ratio: 1.19,
  },
  {
    id: 314,
    species: "cat",
    type: "dry",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Proplan",
    name: "HA Hypoallergenic",
    energy_kcal_kg: 3640.0,
    protein_pct: 35.5,
    rpc: 98.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 315,
    species: "cat",
    type: "dry",
    gamme: "Arthrose",
    brand: "Royal Canin",
    name: "Mobility",
    energy_kcal_kg: 3764.0,
    protein_pct: 28.0,
    rpc: 74.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 316,
    species: "cat",
    type: "dry",
    gamme: "Arthrose",
    brand: "Specific",
    name: "FJD Joint support",
    energy_kcal_kg: 3800.0,
    protein_pct: 27.8,
    rpc: 73.0,
    phosphorus_pct: 0.58,
    p_g_mcal: 1.5,
    rpp: "48",
    calcium_pct: 0.65,
    ca_g_mcal: 1.7,
    ca_p_ratio: 1.12,
  },
  {
    id: 317,
    species: "cat",
    type: "dry",
    gamme: "Arthrose",
    brand: "Hill's",
    name: "Joint mobility",
    energy_kcal_kg: 4100.0,
    protein_pct: 32.0,
    rpc: 78.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 318,
    species: "cat",
    type: "dry",
    gamme: "Bucco-dentaire",
    brand: "Royal Canin",
    name: "Dental",
    energy_kcal_kg: 3722.0,
    protein_pct: 29.0,
    rpc: 78.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 319,
    species: "cat",
    type: "dry",
    gamme: "Bucco-dentaire",
    brand: "Hill's",
    name: "t/d Dental",
    energy_kcal_kg: 3665.0,
    protein_pct: 32.3,
    rpc: 88.0,
    phosphorus_pct: 0.6,
    p_g_mcal: 1.6,
    rpp: "54",
    calcium_pct: 0.9,
    ca_g_mcal: 2.5,
    ca_p_ratio: 1.5,
  },
  {
    id: 320,
    species: "cat",
    type: "dry",
    gamme: "Hyperthryo\u00efdie",
    brand: "Hill's",
    name: "y/d",
    energy_kcal_kg: 4287.0,
    protein_pct: 33.5,
    rpc: 78.0,
    phosphorus_pct: 0.64,
    p_g_mcal: 1.5,
    rpp: "52",
    calcium_pct: 0.86,
    ca_g_mcal: 2.0,
    ca_p_ratio: 1.34,
  },
  {
    id: 321,
    species: "cat",
    type: "dry",
    gamme: "Stress",
    brand: "Royal Canin",
    name: "Calm",
    energy_kcal_kg: 3600.0,
    protein_pct: 36.0,
    rpc: 100.0,
    phosphorus_pct: 1.01,
    p_g_mcal: 2.8,
    rpp: "36",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 322,
    species: "cat",
    type: "dry",
    gamme: "Allergie au chat",
    brand: "Proplan",
    name: "Liveclear kitten",
    energy_kcal_kg: 4400.0,
    protein_pct: 40.0,
    rpc: 91.0,
    phosphorus_pct: 1.27,
    p_g_mcal: 2.9,
    rpp: "31",
    calcium_pct: 1.33,
    ca_g_mcal: 3.0,
    ca_p_ratio: 1.05,
  },
  {
    id: 323,
    species: "cat",
    type: "dry",
    gamme: "Allergie au chat",
    brand: "Proplan",
    name: "Liveclear Adult 1+ sterilised",
    energy_kcal_kg: 3845.0,
    protein_pct: 41.0,
    rpc: 107.0,
    phosphorus_pct: 1.19,
    p_g_mcal: 3.1,
    rpp: "34",
    calcium_pct: 1.41,
    ca_g_mcal: 3.7,
    ca_p_ratio: 1.18,
  },
  {
    id: 324,
    species: "cat",
    type: "dry",
    gamme: "Allergie au chat",
    brand: "Proplan",
    name: "Liveclear Adult 7+",
    energy_kcal_kg: 3966.0,
    protein_pct: 40.0,
    rpc: 101.0,
    phosphorus_pct: 0.98,
    p_g_mcal: 2.5,
    rpp: "41",
    calcium_pct: 1.01,
    ca_g_mcal: 2.5,
    ca_p_ratio: 1.03,
  },
  {
    id: 325,
    species: "cat",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Proplan",
    name: "DM Diabetes",
    energy_kcal_kg: 4120.0,
    protein_pct: 50.0,
    rpc: 121.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 326,
    species: "cat",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Specific",
    name: "FED-DM Endocrine support",
    energy_kcal_kg: 3844.0,
    protein_pct: 50.0,
    rpc: 130.0,
    phosphorus_pct: 0.5,
    p_g_mcal: 1.3,
    rpp: "100",
    calcium_pct: 0.74,
    ca_g_mcal: 1.9,
    ca_p_ratio: 1.48,
  },
  {
    id: 327,
    species: "cat",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Royal Canin",
    name: "Diabetic",
    energy_kcal_kg: 3700.0,
    protein_pct: 46.0,
    rpc: 124.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 328,
    species: "cat",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Hill's",
    name: "m/d diabetes care",
    energy_kcal_kg: 4124.0,
    protein_pct: 47.7,
    rpc: 116.0,
    phosphorus_pct: 0.72,
    p_g_mcal: 1.7,
    rpp: "66",
    calcium_pct: 0.82,
    ca_g_mcal: 2.0,
    ca_p_ratio: 1.14,
  },
  {
    id: 329,
    species: "cat",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Hill's",
    name: "w/d Multi-Benefit",
    energy_kcal_kg: 3370.0,
    protein_pct: 37.1,
    rpc: 110.0,
    phosphorus_pct: 0.79,
    p_g_mcal: 2.3,
    rpp: "47",
    calcium_pct: 0.98,
    ca_g_mcal: 2.9,
    ca_p_ratio: 1.24,
  },
  {
    id: 330,
    species: "cat",
    type: "dry",
    gamme: "Diab\u00e8te",
    brand: "Virbac",
    name: "W1",
    energy_kcal_kg: 3300.0,
    protein_pct: 44.0,
    rpc: 133.0,
    phosphorus_pct: 0.7,
    p_g_mcal: 2.1,
    rpp: "63",
    calcium_pct: 1.3,
    ca_g_mcal: 3.9,
    ca_p_ratio: 1.86,
  },
  {
    id: 331,
    species: "cat",
    type: "dry",
    gamme: "Dermato",
    brand: "Royal Canin",
    name: "Skin & Coat",
    energy_kcal_kg: 3750.0,
    protein_pct: 36.0,
    rpc: null,
    phosphorus_pct: 1.0,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 332,
    species: "cat",
    type: "dry",
    gamme: "H\u00e9patique",
    brand: "Proplan",
    name: "HP Hepatic",
    energy_kcal_kg: 4220.0,
    protein_pct: 28.0,
    rpc: 66.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 333,
    species: "cat",
    type: "dry",
    gamme: "H\u00e9patique",
    brand: "Royal Canin",
    name: "Hepatic",
    energy_kcal_kg: 4034.0,
    protein_pct: 26.0,
    rpc: 64.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 334,
    species: "cat",
    type: "dry",
    gamme: "Autres",
    brand: "Hill's",
    name: "On-Care",
    energy_kcal_kg: 4280.0,
    protein_pct: 33.8,
    rpc: 79.0,
    phosphorus_pct: 0.71,
    p_g_mcal: 1.7,
    rpp: "48",
    calcium_pct: 0.84,
    ca_g_mcal: 2.0,
    ca_p_ratio: 1.18,
  },
  {
    id: 335,
    species: "cat",
    type: "dry",
    gamme: "Autres",
    brand: "Hill's",
    name: "w/d Multi-Benefit",
    energy_kcal_kg: 3370.0,
    protein_pct: 37.1,
    rpc: 110.0,
    phosphorus_pct: 0.79,
    p_g_mcal: 2.3,
    rpp: "47",
    calcium_pct: 0.98,
    ca_g_mcal: 2.9,
    ca_p_ratio: 1.24,
  },
  {
    id: 336,
    species: "cat",
    type: "dry",
    gamme: "Autres",
    brand: "Hill's",
    name: "Multi-benefit No Grain",
    energy_kcal_kg: 4100.0,
    protein_pct: 28.8,
    rpc: 70.0,
    phosphorus_pct: 0.74,
    p_g_mcal: 1.8,
    rpp: "39",
    calcium_pct: 0.76,
    ca_g_mcal: 1.9,
    ca_p_ratio: 1.03,
  },
  {
    id: 337,
    species: "cat",
    type: "dry",
    gamme: "Multifunction",
    brand: "Royal Canin",
    name: "Gastrointestinal + Hydrolysed protein",
    energy_kcal_kg: 4037.0,
    protein_pct: null,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 338,
    species: "cat",
    type: "dry",
    gamme: "Multifunction",
    brand: "Royal Canin",
    name: "Renal + Hypoallergenic",
    energy_kcal_kg: 4102.0,
    protein_pct: null,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 339,
    species: "cat",
    type: "dry",
    gamme: "Multifunction",
    brand: "Royal Canin",
    name: "Urinary + Hypoallergenic",
    energy_kcal_kg: 3772.0,
    protein_pct: null,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 340,
    species: "cat",
    type: "dry",
    gamme: "Multifunction",
    brand: "Royal Canin",
    name: "Urinary + Satiety",
    energy_kcal_kg: 3046.0,
    protein_pct: null,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 341,
    species: "cat",
    type: "dry",
    gamme: "Multifunction",
    brand: "Royal Canin",
    name: "Urinary + Bladder comfort",
    energy_kcal_kg: 3560.0,
    protein_pct: null,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 342,
    species: "cat",
    type: "wet",
    gamme: "Chaton",
    brand: "Royal Canin",
    name: "Mother and Babycat (mousse)",
    energy_kcal_kg: 988.0,
    protein_pct: 10.5,
    rpc: 106.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: "pas pour l'alim en croissance",
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 343,
    species: "cat",
    type: "wet",
    gamme: "Chaton",
    brand: "Royal Canin",
    name: "Kitten (sachet mousse/sauce/gel\u00e9e)",
    energy_kcal_kg: 937.0,
    protein_pct: 12.0,
    rpc: 128.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 344,
    species: "cat",
    type: "wet",
    gamme: "Chaton",
    brand: "Hill's",
    name: "Multi-benefit Kitten",
    energy_kcal_kg: 1025.0,
    protein_pct: 10.0,
    rpc: 98.0,
    phosphorus_pct: 0.24,
    p_g_mcal: 2.3,
    rpp: null,
    calcium_pct: 0.26,
    ca_g_mcal: 2.5,
    ca_p_ratio: 1.08,
  },
  {
    id: 345,
    species: "cat",
    type: "wet",
    gamme: "Chaton",
    brand: "Specific",
    name: "FPW Kitten (terrine)",
    energy_kcal_kg: 1590.0,
    protein_pct: 14.0,
    rpc: 88.0,
    phosphorus_pct: 0.34,
    p_g_mcal: 2.1,
    rpp: null,
    calcium_pct: 0.41,
    ca_g_mcal: 2.6,
    ca_p_ratio: 1.21,
  },
  {
    id: 346,
    species: "cat",
    type: "wet",
    gamme: "Chaton",
    brand: "Proplan",
    name: "Kitten Healtystart (sachet sauce)",
    energy_kcal_kg: 967.0,
    protein_pct: 12.5,
    rpc: 129.0,
    phosphorus_pct: 0.24,
    p_g_mcal: 2.5,
    rpp: null,
    calcium_pct: 0.34,
    ca_g_mcal: 3.5,
    ca_p_ratio: 1.42,
  },
  {
    id: 347,
    species: "cat",
    type: "wet",
    gamme: "Chaton",
    brand: "Proplan",
    name: "Kitten Healtystart (sachet terrine)",
    energy_kcal_kg: 834.0,
    protein_pct: 9.0,
    rpc: 108.0,
    phosphorus_pct: 0.24,
    p_g_mcal: 2.9,
    rpp: null,
    calcium_pct: 0.35,
    ca_g_mcal: 4.2,
    ca_p_ratio: 1.46,
  },
  {
    id: 348,
    species: "cat",
    type: "wet",
    gamme: "Chaton",
    brand: "Proplan",
    name: "Kitten Healtystart (bo\u00eete mousse)",
    energy_kcal_kg: 1192.0,
    protein_pct: 13.0,
    rpc: 109.0,
    phosphorus_pct: 0.41,
    p_g_mcal: 3.4,
    rpp: null,
    calcium_pct: 0.41,
    ca_g_mcal: 3.4,
    ca_p_ratio: 1.0,
  },
  {
    id: 349,
    species: "cat",
    type: "wet",
    gamme: "Chaton st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Sterilised kitten (gel\u00e9e)",
    energy_kcal_kg: 790.0,
    protein_pct: 10.5,
    rpc: 133.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 350,
    species: "cat",
    type: "wet",
    gamme: "Chaton st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Sterilised kitten (sauce)",
    energy_kcal_kg: 850.0,
    protein_pct: 11.0,
    rpc: 129.0,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 351,
    species: "cat",
    type: "wet",
    gamme: "Adulte",
    brand: "Specific",
    name: "FXW Adult (terrine)",
    energy_kcal_kg: 980.0,
    protein_pct: 11.0,
    rpc: 112.0,
    phosphorus_pct: 0.17,
    p_g_mcal: 1.7,
    rpp: "65",
    calcium_pct: 0.21,
    ca_g_mcal: 2.1,
    ca_p_ratio: 1.24,
  },
  {
    id: 352,
    species: "cat",
    type: "wet",
    gamme: "Adulte",
    brand: "Specific",
    name: "FXW (sachet)",
    energy_kcal_kg: 1030.0,
    protein_pct: 11.0,
    rpc: 107.0,
    phosphorus_pct: 0.18,
    p_g_mcal: 1.7,
    rpp: "61",
    calcium_pct: 0.21,
    ca_g_mcal: 2.0,
    ca_p_ratio: 1.17,
  },
  {
    id: 353,
    species: "cat",
    type: "wet",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit Adult poulet",
    energy_kcal_kg: 820.0,
    protein_pct: 7.8,
    rpc: 95.0,
    phosphorus_pct: 0.14,
    p_g_mcal: 1.7,
    rpp: "56",
    calcium_pct: 0.19,
    ca_g_mcal: 2.3,
    ca_p_ratio: 1.36,
  },
  {
    id: 354,
    species: "cat",
    type: "wet",
    gamme: "Adulte",
    brand: "Hill's",
    name: "Multi-benefit Adult saumon",
    energy_kcal_kg: 831.0,
    protein_pct: 7.5,
    rpc: 90.0,
    phosphorus_pct: 0.13,
    p_g_mcal: 1.6,
    rpp: "58",
    calcium_pct: 0.15,
    ca_g_mcal: 1.8,
    ca_p_ratio: 1.15,
  },
  {
    id: 355,
    species: "cat",
    type: "wet",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Adult Delicate digestion poisson/dinde (sachet)",
    energy_kcal_kg: 953.0,
    protein_pct: 12.6,
    rpc: 132.0,
    phosphorus_pct: 0.23,
    p_g_mcal: 2.4,
    rpp: "55",
    calcium_pct: 0.34,
    ca_g_mcal: 3.6,
    ca_p_ratio: 1.48,
  },
  {
    id: 356,
    species: "cat",
    type: "wet",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Adulte Delicate (bo\u00eete mousse)",
    energy_kcal_kg: 1209.0,
    protein_pct: 11.0,
    rpc: 91.0,
    phosphorus_pct: 0.42,
    p_g_mcal: 3.5,
    rpp: "26",
    calcium_pct: 0.48,
    ca_g_mcal: 4.0,
    ca_p_ratio: 1.14,
  },
  {
    id: 357,
    species: "cat",
    type: "wet",
    gamme: "Adulte",
    brand: "Proplan",
    name: "Adult Maintenance",
    energy_kcal_kg: 1077.0,
    protein_pct: 12.5,
    rpc: 116.0,
    phosphorus_pct: 0.37,
    p_g_mcal: 3.4,
    rpp: "34",
    calcium_pct: 0.37,
    ca_g_mcal: 3.4,
    ca_p_ratio: 1.0,
  },
  {
    id: 358,
    species: "cat",
    type: "wet",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Virbac",
    name: "Neutered",
    energy_kcal_kg: 890.0,
    protein_pct: 11.5,
    rpc: null,
    phosphorus_pct: 0.17,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.2,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 359,
    species: "cat",
    type: "wet",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Neutered maintenance",
    energy_kcal_kg: 862.0,
    protein_pct: 10.0,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 360,
    species: "cat",
    type: "wet",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Royal Canin",
    name: "Neutered balance",
    energy_kcal_kg: 721.0,
    protein_pct: 9.0,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 361,
    species: "cat",
    type: "wet",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Specific",
    name: "FXW Adult",
    energy_kcal_kg: 980.0,
    protein_pct: 11.0,
    rpc: null,
    phosphorus_pct: 0.17,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.21,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 362,
    species: "cat",
    type: "wet",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Hill's",
    name: "Multi-benefit + Low fat + High fibre",
    energy_kcal_kg: 707.0,
    protein_pct: 7.5,
    rpc: null,
    phosphorus_pct: 0.13,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.15,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 363,
    species: "cat",
    type: "wet",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "Sterilised Adult Maintenance poulet/boeuf (sachet)",
    energy_kcal_kg: 938.0,
    protein_pct: 13.0,
    rpc: null,
    phosphorus_pct: 0.22,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.36,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 364,
    species: "cat",
    type: "wet",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "Sterilised Adult Maintenance cabillaud (sachet)",
    energy_kcal_kg: 809.0,
    protein_pct: 9.5,
    rpc: null,
    phosphorus_pct: 0.23,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.32,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 365,
    species: "cat",
    type: "wet",
    gamme: "Adulte st\u00e9rilis\u00e9",
    brand: "Proplan",
    name: "Sterilised Adult Maintenance saumon/thon (bo\u00eete)",
    energy_kcal_kg: 1021.0,
    protein_pct: 13.0,
    rpc: null,
    phosphorus_pct: 0.41,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.43,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 366,
    species: "cat",
    type: "wet",
    gamme: "Senior",
    brand: "Specific",
    name: "FGD Senior",
    energy_kcal_kg: 1520.0,
    protein_pct: 10.4,
    rpc: null,
    phosphorus_pct: 0.17,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.21,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 367,
    species: "cat",
    type: "wet",
    gamme: "Senior",
    brand: "Hill's",
    name: "Multi-benefit Chat mature",
    energy_kcal_kg: 914.0,
    protein_pct: 8.2,
    rpc: null,
    phosphorus_pct: 0.14,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.21,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 368,
    species: "cat",
    type: "wet",
    gamme: "Senior",
    brand: "Proplan",
    name: "Sterilised Senior Longevis 7+ Dinde (sachet terrine)",
    energy_kcal_kg: 907.0,
    protein_pct: 9.0,
    rpc: null,
    phosphorus_pct: 0.23,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.27,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 369,
    species: "cat",
    type: "wet",
    gamme: "Senior",
    brand: "Proplan",
    name: "Senior Longevis 7+ (bo\u00eete mousse)",
    energy_kcal_kg: 1209.0,
    protein_pct: 11.0,
    rpc: null,
    phosphorus_pct: 0.37,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.37,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 370,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Early Renal",
    energy_kcal_kg: 971.0,
    protein_pct: 8.5,
    rpc: null,
    phosphorus_pct: 0.15,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.18,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 371,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal",
    energy_kcal_kg: 1053.0,
    protein_pct: 7.5,
    rpc: null,
    phosphorus_pct: 0.1,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.15,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 372,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal with chicken",
    energy_kcal_kg: 1177.0,
    protein_pct: 7.8,
    rpc: null,
    phosphorus_pct: 0.09,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.15,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 373,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal with beef",
    energy_kcal_kg: 1008.0,
    protein_pct: 6.7,
    rpc: null,
    phosphorus_pct: 0.075,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.13,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 374,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Royal Canin",
    name: "Renal with fish",
    energy_kcal_kg: 950.0,
    protein_pct: 6.6,
    rpc: null,
    phosphorus_pct: 0.09,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.14,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 375,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Proplan",
    name: "Renal Function Early Care (sachet)",
    energy_kcal_kg: 990.0,
    protein_pct: 8.5,
    rpc: null,
    phosphorus_pct: 0.11,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.17,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 376,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Proplan",
    name: "Renal Function Advanced Function (sachet)",
    energy_kcal_kg: 1230.0,
    protein_pct: 7.2,
    rpc: null,
    phosphorus_pct: 0.11,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.18,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 377,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Proplan",
    name: "Renal Function Advanced Function (bo\u00eete)",
    energy_kcal_kg: 1120.0,
    protein_pct: 7.0,
    rpc: null,
    phosphorus_pct: 0.09,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.23,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 378,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d Kidney care Early stage (sachet)",
    energy_kcal_kg: 957.0,
    protein_pct: 7.4,
    rpc: null,
    phosphorus_pct: 0.11,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.17,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 379,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d Kidney care (sachet et bo\u00eete)",
    energy_kcal_kg: 893.0,
    protein_pct: 6.1,
    rpc: null,
    phosphorus_pct: 0.09,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 380,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d + Mobility (bo\u00eete)",
    energy_kcal_kg: 835.0,
    protein_pct: 5.7,
    rpc: null,
    phosphorus_pct: 0.09,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.14,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 381,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Hill's",
    name: "k/d + Mobility (sachet poulet)",
    energy_kcal_kg: 905.0,
    protein_pct: 6.2,
    rpc: null,
    phosphorus_pct: 0.09,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.17,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 382,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Virbac",
    name: "KJ1 Early Kidney & Joint",
    energy_kcal_kg: 993.0,
    protein_pct: 12.0,
    rpc: null,
    phosphorus_pct: 0.17,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.25,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 383,
    species: "cat",
    type: "wet",
    gamme: "R\u00e9nal",
    brand: "Virbac",
    name: "KJ2 Kidney & Joint",
    energy_kcal_kg: 1237.0,
    protein_pct: 11.0,
    rpc: null,
    phosphorus_pct: 0.15,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.28,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 384,
    species: "cat",
    type: "wet",
    gamme: "Surpoids",
    brand: "Royal Canin",
    name: "Satiety Weight management",
    energy_kcal_kg: 610.0,
    protein_pct: 7.5,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 385,
    species: "cat",
    type: "wet",
    gamme: "Surpoids",
    brand: "Hill's",
    name: "Metabolic (sachet)",
    energy_kcal_kg: 665.0,
    protein_pct: 7.6,
    rpc: null,
    phosphorus_pct: 0.14,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.19,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 386,
    species: "cat",
    type: "wet",
    gamme: "Surpoids",
    brand: "Hill's",
    name: "Metabolic (bo\u00eete)",
    energy_kcal_kg: 784.0,
    protein_pct: 8.3,
    rpc: null,
    phosphorus_pct: 0.15,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.22,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 387,
    species: "cat",
    type: "wet",
    gamme: "Surpoids",
    brand: "Proplan",
    name: "OM Obesity (sachet)",
    energy_kcal_kg: 700.0,
    protein_pct: 10.6,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 388,
    species: "cat",
    type: "wet",
    gamme: "Urinaire",
    brand: "Virbac",
    name: "Dissolution et pr\u00e9vention des calculs urinaires",
    energy_kcal_kg: 930.0,
    protein_pct: 11.0,
    rpc: null,
    phosphorus_pct: 0.15,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.22,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 389,
    species: "cat",
    type: "wet",
    gamme: "Urinaire",
    brand: "Royal Canin",
    name: "Urinary s/o mousse",
    energy_kcal_kg: 845.0,
    protein_pct: 11.0,
    rpc: null,
    phosphorus_pct: 0.25,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.25,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 390,
    species: "cat",
    type: "wet",
    gamme: "Urinaire",
    brand: "Royal Canin",
    name: "Urinary s/o sauce",
    energy_kcal_kg: 830.0,
    protein_pct: 10.0,
    rpc: null,
    phosphorus_pct: 0.2,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.23,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 391,
    species: "cat",
    type: "wet",
    gamme: "Urinaire",
    brand: "Royal Canin",
    name: "Urinary s/o moderate calorie",
    energy_kcal_kg: 730.0,
    protein_pct: 9.5,
    rpc: null,
    phosphorus_pct: 0.19,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.22,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 392,
    species: "cat",
    type: "wet",
    gamme: "Urinaire",
    brand: "Specific",
    name: "FCD Crystal Management",
    energy_kcal_kg: 1380.0,
    protein_pct: 11.0,
    rpc: null,
    phosphorus_pct: 0.18,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.21,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 393,
    species: "cat",
    type: "wet",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "c/d Urinary Care multicare (bo\u00eete et sachet)",
    energy_kcal_kg: 839.0,
    protein_pct: 8.3,
    rpc: null,
    phosphorus_pct: 0.13,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.16,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 394,
    species: "cat",
    type: "wet",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "c/d Urinary care multicare stress (bo\u00eete et sachet)",
    energy_kcal_kg: 837.0,
    protein_pct: 8.9,
    rpc: null,
    phosphorus_pct: 0.13,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 395,
    species: "cat",
    type: "wet",
    gamme: "Urinaire",
    brand: "Hill's",
    name: "c/d Urinary Stress + metabolic (sachet)",
    energy_kcal_kg: 684.0,
    protein_pct: 7.7,
    rpc: null,
    phosphorus_pct: 0.15,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.16,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 396,
    species: "cat",
    type: "wet",
    gamme: "Urinaire",
    brand: "Proplan",
    name: "UR Urinary (sachet et bo\u00eete)",
    energy_kcal_kg: 900.0,
    protein_pct: 9.5,
    rpc: null,
    phosphorus_pct: 0.16,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.16,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 397,
    species: "cat",
    type: "wet",
    gamme: "Gastrointestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal",
    energy_kcal_kg: 955.0,
    protein_pct: 8.0,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 398,
    species: "cat",
    type: "wet",
    gamme: "Gastrointestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal fibre response",
    energy_kcal_kg: 750.0,
    protein_pct: 7.1,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 399,
    species: "cat",
    type: "wet",
    gamme: "Gastrointestinal",
    brand: "Royal Canin",
    name: "Gastrointestinal moderate calorie",
    energy_kcal_kg: 729.0,
    protein_pct: 7.0,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 400,
    species: "cat",
    type: "wet",
    gamme: "Gastrointestinal",
    brand: "Royal Canin",
    name: "Gastrotintestinal kitten (bo\u00eete)",
    energy_kcal_kg: 999.0,
    protein_pct: 11.0,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.3,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 401,
    species: "cat",
    type: "wet",
    gamme: "Gastrointestinal",
    brand: "Hill's",
    name: "i/d Digestive care (sachet)",
    energy_kcal_kg: 851.0,
    protein_pct: 7.6,
    rpc: null,
    phosphorus_pct: 0.17,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.23,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 402,
    species: "cat",
    type: "wet",
    gamme: "Gastrointestinal",
    brand: "Hill's",
    name: "i/d Digestive care (bo\u00eete)",
    energy_kcal_kg: 1126.0,
    protein_pct: 9.7,
    rpc: null,
    phosphorus_pct: 0.23,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.31,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 403,
    species: "cat",
    type: "wet",
    gamme: "Gastrointestinal",
    brand: "Hill's",
    name: "Gastrointestinal Biome (sachet)",
    energy_kcal_kg: 962.0,
    protein_pct: 8.9,
    rpc: null,
    phosphorus_pct: 0.16,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.2,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 404,
    species: "cat",
    type: "wet",
    gamme: "Gastrointestinal",
    brand: "Hill's",
    name: "Gastrointestinal Biome (bo\u00eete)",
    energy_kcal_kg: 822.0,
    protein_pct: 7.5,
    rpc: null,
    phosphorus_pct: 0.13,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.19,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 405,
    species: "cat",
    type: "wet",
    gamme: "Gastrointestinal",
    brand: "Proplan",
    name: "EN Gastrointestinal (bo\u00eete et sachet)",
    energy_kcal_kg: 1100.0,
    protein_pct: 10.5,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 406,
    species: "cat",
    type: "wet",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Royal Canin",
    name: "Sensitivity Control",
    energy_kcal_kg: 960.0,
    protein_pct: 7.0,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 407,
    species: "cat",
    type: "wet",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Specific",
    name: "FDW Food Allergen Management",
    energy_kcal_kg: 1440.0,
    protein_pct: 9.0,
    rpc: null,
    phosphorus_pct: 0.23,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.29,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 408,
    species: "cat",
    type: "wet",
    gamme: "Hypoallerg\u00e9nique",
    brand: "Hill's",
    name: "z/d Food Sensitivities (bo\u00eete)",
    energy_kcal_kg: 1146.0,
    protein_pct: 9.2,
    rpc: null,
    phosphorus_pct: 0.2,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.23,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 409,
    species: "cat",
    type: "wet",
    gamme: "Arthrose",
    brand: "Hill's",
    name: "k/d + Mobility (bo\u00eete)",
    energy_kcal_kg: 835.0,
    protein_pct: 5.7,
    rpc: null,
    phosphorus_pct: 0.09,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.14,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 410,
    species: "cat",
    type: "wet",
    gamme: "Arthrose",
    brand: "Hill's",
    name: "k/d + Mobility (sachet poulet)",
    energy_kcal_kg: 905.0,
    protein_pct: 6.2,
    rpc: null,
    phosphorus_pct: 0.09,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.17,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 411,
    species: "cat",
    type: "wet",
    gamme: "Hyperthryo\u00efdie",
    brand: "Hill's",
    name: "y/d",
    energy_kcal_kg: 1241.0,
    protein_pct: 9.0,
    rpc: null,
    phosphorus_pct: 0.14,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.22,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 412,
    species: "cat",
    type: "wet",
    gamme: "Diab\u00e8te",
    brand: "Proplan",
    name: "DM Diabetes (bo\u00eete et sachet)",
    energy_kcal_kg: 1000.0,
    protein_pct: 13.8,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 413,
    species: "cat",
    type: "wet",
    gamme: "Diab\u00e8te",
    brand: "Royal Canin",
    name: "Diabetic",
    energy_kcal_kg: 722.0,
    protein_pct: 8.9,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 414,
    species: "cat",
    type: "wet",
    gamme: "Diab\u00e8te",
    brand: "Hill's",
    name: "w/d Multi-Benefit (bo\u00eete et sachet)",
    energy_kcal_kg: 821.0,
    protein_pct: 9.3,
    rpc: null,
    phosphorus_pct: 0.16,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.2,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 415,
    species: "cat",
    type: "wet",
    gamme: "Dermato",
    brand: "Royal Canin",
    name: "Skin & Coat",
    energy_kcal_kg: 917.0,
    protein_pct: 9.8,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 416,
    species: "cat",
    type: "wet",
    gamme: "Autres",
    brand: "Hill's",
    name: "On-Care",
    energy_kcal_kg: 936.0,
    protein_pct: 8.9,
    rpc: null,
    phosphorus_pct: 0.15,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.19,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 417,
    species: "cat",
    type: "wet",
    gamme: "Autres",
    brand: "Hill's",
    name: "a/d Urgent care",
    energy_kcal_kg: 1310.0,
    protein_pct: 12.9,
    rpc: null,
    phosphorus_pct: 0.27,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.31,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 418,
    species: "cat",
    type: "wet",
    gamme: "Autres",
    brand: "Hill's",
    name: "w/d Multi-Benefit",
    energy_kcal_kg: 821.0,
    protein_pct: 9.3,
    rpc: null,
    phosphorus_pct: 0.16,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.2,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 419,
    species: "cat",
    type: "wet",
    gamme: "Autres",
    brand: "Proplan",
    name: "CN Convalescence",
    energy_kcal_kg: 1120.0,
    protein_pct: 10.9,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 420,
    species: "cat",
    type: "wet",
    gamme: "Autres",
    brand: "Royal Canin",
    name: "Recovery bo\u00eete",
    energy_kcal_kg: 1183.0,
    protein_pct: 12.7,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 421,
    species: "cat",
    type: "wet",
    gamme: "Autres",
    brand: "Royal Canin",
    name: "Recovery liquid",
    energy_kcal_kg: 1050.0,
    protein_pct: 8.2,
    rpc: null,
    phosphorus_pct: null,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: null,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 422,
    species: "cat",
    type: "wet",
    gamme: "Autres",
    brand: "Royal Canin",
    name: "Renal liquid",
    energy_kcal_kg: 1050.0,
    protein_pct: 7.0,
    rpc: null,
    phosphorus_pct: 0.08,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.1,
    ca_g_mcal: null,
    ca_p_ratio: null,
  },
  {
    id: 423,
    species: "cat",
    type: "wet",
    gamme: "Autres",
    brand: "Specific",
    name: "F-Bio-W",
    energy_kcal_kg: 951.0,
    protein_pct: 8.9,
    rpc: null,
    phosphorus_pct: 0.29,
    p_g_mcal: null,
    rpp: null,
    calcium_pct: 0.3,
    ca_g_mcal: null,
    ca_p_ratio: null,
  }
];